<template>
  <div>
    <div class="container" :class="{'plus-container':plusContainer}">
      <header>
        <div class="navigation">
          <span style="cursor: pointer">
            <!-- <a @click="toRouter"
              ><span class="menu">{{ form.menuContent }}</span></a
            > -->
            <span class="menu" @click="$router.push({path:'/'})">Home</span>
            <span style="margin: 0 10px">/</span>
            <span v-for="(item,index) in form.menuList" :key="item.id">
              <a @click="gotoShopvidi(item)" class="menu"
                >{{ item.title
                }}<span v-if="index !== form.menuList.length-1" style="margin: 0 10px" class="menu">/</span></a
              >
            </span>
          </span>
          <!-- <span class="goods-title">{{ goodsTitle }}</span> -->
        </div>
        <el-divider></el-divider>
      </header>
      <div class="goods-content">
        <div class="goods-content-img" v-if="!isMod || isIpad">
          <!-- 缩略图 -->
          <div class="img-abbr">
            <span
              class="img-abbr-block"
              v-for="(fileDetail, index) in fileDetails"
              :key="index"
            >
              <div class="abbr-img">
                <img
                  :class="{'abbr-img-width':getImgAbbr(fileDetail),'abbr-img-height':!getImgAbbr(fileDetail)}"
                  :src="fileDetail"
                  :preview="-1"
                  :datakey="index"
                  @click="selectImgAbbr(fileDetail, index)"
                  @mouseover="selectImgAbbr(fileDetail, index)"
                />
              </div>
            </span>
          </div>
          <!-- 预览图 -->
          <div class="img-pre">
            <div v-if="showOneClickOrder" class="product-vilocal-tag">
              <img src="@/assets/img/product/product-vilocal.png"/>
            </div>
            <div class="img-pre-left" @click="prev">
              <img src="@/assets/left.png" alt="">
            </div>
            <img :class="{'img-pre-item':imgWidth<=imgHeight,'img-pre-item-width':imgWidth>imgHeight}" :src="preImg" />
            <div class="img-pre-right" @click="next">
              <img src="@/assets/right.png" alt="">
            </div>
          </div>
        </div>
        <div class="img-container">
          <mt-swipe :auto="0" v-if="isMod" :defaultIndex="defaultIndex" ref="swipe">
            <mt-swipe-item v-for="(img, index) in fileDetails" :key="index">
              <div v-if="showOneClickOrder" class="product-vilocal-tag">
                <img src="@/assets/img/product/product-vilocal.png"/>
              </div>
              <img :class="{'img-pre-item':imgWidth<=imgHeight,'img-pre-item-width':imgWidth>imgHeight}"  :src="img" :key="index" />
            </mt-swipe-item>
          </mt-swipe>
        </div>
        <!-- 商品sku信息 -->
        <!-- pc -->
        <div class="goods-content-sku">
          <!-- 品牌信息 -->
          <div
            class="brand-content"
            style="overflow: hidden"
            v-if="collectionBrandId !== '' && collectionBrandId !== null"
          >
            <img
              :src="collectionBrandLogoUrl"
              style="
                height: 50px;
                width: 50px;
                float: left;
                border: 1px solid #e6e6e6;
                border-radius: 50%;
              "
            />
            <div class="collection_brand">
                <!-- 品牌名字，评分和卖点 -->
                <div class="brand_name_rating">
                  <a
                    href="javascript:void(0)"
                    @click="gotoBrand"
                    style="
                      font-size: 16px;
                      color: #262b2f;
                      text-decoration: underline;
                      font-weight: 500;
                      line-height:35px;
                      margin-left: 10px;
                      float:left;
                      cursor: pointer;
                    "
                    >{{ collectionBrandName }}
                  </a>
                  <!-- 评分区 queryData.collectionBdScore-->
                  <div class="total-reviews" v-if="queryData['rating']" @click="showCollection=!showCollection" >
                    <el-rate
                      v-model="queryData['rating']"
                      disabled
                      :allowHalf="true"
                      style="width: 85px;margin-top:-5px"
                      disabled-void-color="#000"
                      disabled-void-icon-class="el-icon-star-off"
                      :colors="colors"
                      text-color="#262B2F"
                      >
                    </el-rate>
                    <span class="ratingStr">{{queryData['ratingStr']}}</span>
                    <i class="el-icon-arrow-down" style="margin-top:-5px"></i>
                    <div class="rating-collection" v-if="showCollection" ref="ratingCollection" >
                      <p>
                        <span>Product Quality</span>
                        <el-rate v-model="queryData['descriptionRating']" disabled  :allowHalf="true"  :colors="colors"  disabled-void-color="#000" disabled-void-icon-class="el-icon-star-off" text-color="#262B2F">
                        </el-rate>
                        <span class="rating">{{queryData['productQuality']}}</span>
                      </p>
                      <p>
                          <span> Brand Service</span>
                        <el-rate v-model="queryData['serviceRating']" disabled  :allowHalf="true"  :colors="colors"  disabled-void-color="#000" disabled-void-icon-class="el-icon-star-off" text-color="#262B2F" >
                        </el-rate>
                        <span class="rating">{{queryData['brandServiceStr']}}</span>
                      </p>
                      <p>
                        <span> Logistics Rating</span>
                          <el-rate v-model="queryData['logisticsRating']" disabled  :allowHalf="true" :colors="colors"  disabled-void-color="#000" disabled-void-icon-class="el-icon-star-off"  text-color="#262B2F">
                        </el-rate>
                        <span class="rating">{{queryData['logisticsRatingStr']}}</span>
                      </p>
                    </div>
                  </div>
                  <!-- 评分区 end -->
                  <div v-if="queryData['brandIsVilocal']" class="brand-vilocal">ViLocal</div>
                  <el-tag v-if="salesManager !== '' && salesManager !== null"  type="danger">Top Brand</el-tag>
                </div>
                <div>
                  <span v-if="(!isMobile || isIpad) && queryData.collectionBrandSellingPoint && collectionBrandId !== '' && collectionBrandId !== null" class="selling-point">
                      ({{queryData.collectionBrandSellingPoint}})
                  </span>
                </div>
            </div>
          </div>
          <p class="title-main">
            {{ goodsTitle }}
          </p>
          <!-- <p class="goods-id">Product ID：{{ id }}</p> -->
          <p></p>
            <!-- <span v-if="login || showWholesalePrice" class="sku-title new-title" style="width: 120px; margin-right: 5px"
              >Wholesale Price</span
            > -->
          <div  v-if="!login && showReailPrice" class="lock-item">
            <img src="../../assets/img/lock1.png" />
            <span>Sign up to see wholesale price</span>
          </div>
            <div v-if="login || showWholesalePrice" class="price" style="color: #262b2f">
              <span v-if="queryData['brandIsVilocal'] && skuInfo['isVilocal'] && skuInfo['vilocalType']==4">$ {{ discountPrice }}</span>
              <span :class="(queryData['brandIsVilocal'] && skuInfo['isVilocal'] && skuInfo['vilocalType']==4)&&'original-price' ">$ {{ Number(price).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,') }}</span>
            </div>
            <!-- <span class="line" v-if="!isMod && (login || (showWholesalePrice && showReailPrice))" >|</span> -->
            <div>
              <span v-if="login || showReailPrice" class="sku-title" style="width: 80px;">Retail Price</span>
              <label v-if="login || showReailPrice" class="net-price" style="font-size: 16px">
                <!-- ${{ Number(netPrice).toFixed(2) }} -->
                ${{ Number(netPrice).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,') }}
              </label>
                <span class="margin-button" v-if="login">Margin {{(Number((netPrice-price)/netPrice)*100).toFixed(2)}}%</span>
            </div>
            <!-- 折扣率 -->
            <div v-if="login && queryData['brandIsVilocal'] && skuInfo['isVilocal'] && skuInfo['vilocalType']==4">
              <span class="discount-trial-rate">
                <img width="16px" height="16px" style="margin-right: 5px;background-color: #ff4812;"  src="https://s3-amazonaws.shopvidi.com/common/test/2024103010/1575136157821255681/picture-library/1eb256af-bc46-4945-85fd-61975a7f4295.png">
                {{(Number(skuInfo.discountTrialDisplayRate)*100).toFixed(0)}}% OFF
              </span>
            </div>
            <div class="ships-from" v-if="queryData.collectionBrandShippingCountryCode">
              Fulfills orders within {{queryData.logisticsEfficiency}} days
            </div>

            <!-- <span
              class="sku-title aboutProfit"
              style="width: 100px; margin-right: 0px"
              v-if="!isMod && (login || (showWholesalePrice && showReailPrice))"
              >Earn&nbsp;{{
                aboutProfit
                  ? "$" + Number(aboutProfit).toFixed(2)
                  : Number(aboutProfit).toFixed(2)
              }}</span
            >
          </p>-->

          <div
            class="sku-contont"
            v-if="attObj.att0Flag"
            :key="attObj.att0Name"
          >
            <div
              class="sku-title sku-title-left sku-block"
              style="width: 100%; margin-right: 38px"
            >
              {{ attObj.att0Name }}
            </div>
            <div class="type-btn">
              <span
                class="ctn-btn"
                v-for="(itm, idx) in attObj.att0Arr"
                :key="itm.value"
                :data-key="itm.value"
                v-bind:class="{ active: idx == isActive0 }"
                @click="checkedSizeItem($event, idx, 0, attObj.att0Name)"
              >
                {{ itm.name }}
              </span>
            </div>
          </div>
          <div
            class="sku-contont"
            v-if="attObj.att1Flag"
            :key="attObj.att1Name"
          >
            <span
              class="sku-title sku-title-left sku-block"
              style="width: 62px; margin-right: 38px"
            >
              {{ attObj.att1Name }}
            </span>
            <div class="type-btn">
              <span
                class="ctn-btn"
                v-for="(itm, idx) in attObj.att1Arr"
                :key="itm.value"
                :data-key="itm.value"
                v-bind:class="{ active: idx == isActive1 }"
                @click="checkedSizeItem($event, idx, 1, attObj.att1Name)"
              >
                {{ itm.name }}
              </span>
            </div>
          </div>

          <div
            class="sku-contont"
            v-if="attObj.att2Flag"
            :key="attObj.att2Name"
          >
            <span
              class="sku-title sku-title-left sku-block"
              style="width: 62px; margin-right: 38px"
            >
              {{ attObj.att2Name }}
            </span>
            <div class="type-btn">
              <span
                class="ctn-btn"
                v-for="(itm, idx) in attObj.att2Arr"
                :key="itm.value"
                :data-key="itm.value"
                v-bind:class="{ active: idx == isActive2 }"
                @click="checkedSizeItem($event, idx, 2, attObj.att2Name)"
              >
                {{ itm.name }}
              </span>
            </div>
          </div>
          <div
            class="sku-contont"
            v-if="attObj.att3Flag"
            :key="attObj.att3Name"
          >
            <span
              class="sku-title sku-title-left sku-block"
              style="width: 62px; margin-right: 38px"
            >
              {{ attObj.att3Name }}
            </span>
            <div class="type-btn">
              <span
                class="ctn-btn"
                v-for="(itm, idx) in attObj.att3Arr"
                :key="itm.value"
                :data-key="itm.value"
                v-bind:class="{ active: idx == isActive3 }"
                @click="checkedSizeItem($event, idx, 3, attObj.att3Name)"
              >
                {{ itm.name }}
              </span>
            </div>
          </div>
          <div
            class="sku-contont"
            v-if="attObj.att4Flag"
            :key="attObj.att4Name"
          >
            <span
              class="sku-title sku-title-left sku-block"
              style="width: 62px; margin-right: 38px"
            >
              {{ attObj.att4Name }}
            </span>
            <div class="type-btn">
              <span
                class="ctn-btn"
                v-for="(itm, idx) in attObj.att4Arr"
                :key="itm.value"
                :data-key="itm.value"
                v-bind:class="{ active: idx == isActive4 }"
                @click="checkedSizeItem($event, idx, 4, attObj.att4Name)"
              >
                {{ itm.name }}
              </span>
            </div>
          </div>
          <div
            class="sku-contont"
            v-if="attObj.att5Flag"
            :key="attObj.att5Name"
          >
            <span
              class="sku-title sku-title-left sku-block"
              style="width: 62px; margin-right: 38px"
            >
              {{ attObj.att5Name }}
            </span>
            <div class="type-btn">
              <span
                class="ctn-btn"
                v-for="(itm, idx) in attObj.att5Arr"
                :key="itm.value"
                :data-key="itm.value"
                v-bind:class="{ active: idx == isActive5 }"
                @click="checkedSizeItem($event, idx, 5, attObj.att5Name)"
              >
                {{ itm.name }}
              </span>
            </div>
          </div>
          <div>
            <div
              class="sku-title sku-block sku-title-left"
              style="margin-right: 26px;"
              >Quantity  <span v-if="goodCase>1" style="color:#5D5D5D">（Case size {{goodCase}}）</span>
            </div>
            <div>
              <el-input-number v-model="num" :step="goodCase?goodCase:1" :min="moq > goodCase ? moq : goodCase" @change="changeQuantity"></el-input-number>
            </div>
            <div class="vilocal-type-tips">{{vilocalTypeTips}}</div>
          </div>
          <p class="item-bottom">
            <!--            <span
              class="num-btn"
              onselectstart="return false"
              @click="changeNum(true)"
              >─</span
            >
            <el-input
              v-model="num"
              @change="getTotalPrice()"
              @blur="blurInpNum"
              class="num"
            ></el-input>
            <span
              class="num-btn"
              onselectstart="return false"
              @click="changeNum(false)"
              >+</span
            >-->

            <!-- <span class="sku-title inventory" style="width: 72px"
              >Inventory</span
            >
            <span class="stockNum">{{ stockNum }}</span> -->
          </p>
          <!-- <div class="item-bottom ship-method-con">
            <span class="sku-title sku-block pre-title shipping-Mrthod"
              >Shipping Method</span
            >
            <span
              style="
                display: inline-block;
                width: 326px;
                height: 20px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                background: #ffffff;
                border: 1px solid #e1e1e1;
                border-radius: 3px;
                padding: 2px;
                font-size: 14px;
                font-family: PingFang SC;
                line-height: 20px;
                color: #262b2f;
                margin-bottom: 15px;
              "
              @click="queryShopingMethod"
            >
              <span v-if="showShopMethodDefault" style="color: #999">
                Please select Shipping Method
              </span>
              <span v-else disabled
                >ship to {{ tempShippingToText }} {{ days }} day | ${{
                  freight
                }}
              </span>
            </span>
          </div> -->
          <!-- <p class="item-bottom" v-if="login">
            <span class="sku-title pre-title">Total Price</span>
            <span class="totalPrice">${{ totalPrice }}</span>
          </p>-->
          <!-- <p class="item-bottom">
            <span class="sku-title pre-title">Weight</span>
            <label class="pre-val">{{ weight }} {{ unit }}</label>
          </p> -->
          <!-- <p class="item-bottom">
            <span class="sku-title pre-title">SKU</span>
            <label class="pre-val">{{ skuId }}</label>
          </p>-->

          <div style="margin-top: 50px">
<!--            <div class="sold-out" v-if="goodsStatus === '0'">
              <span class="btn top-btn" style="background-color: #e1e1e1"
                >Sold Out</span
              >
            </div>-->
            <div class="sold-out button_box" v-if="unAvailableSku" >
              <span class="btn top-btn un-available" style="background-color: #5D5D5D;color: #fff;cursor: not-allowed;">Unavailable</span>
            </div>
            <div class="sold-out button_box" v-if="!unAvailableSku && (goodsStatus == '0' || skuStatus=='2')">
              <span class="btn top-btn" style="background-color: hsl(0, 0%, 36%);color: #fff;cursor: not-allowed;"
                >Sold Out</span
              >
            </div>
            <div v-if="(goodsStatus === '1' ) && (skuStatus=='1' || skuStatus==='')" class="button_box">
              <!-- <span class="btn top-btn" @click="visible = true">
                Import List
              </span> -->
              <!-- <span
                v-if="goodsStatus === '1'"
                @click="buySample"
                style="background-color: #ff4812; margin-left: 0px"
                class="btn buy-btn"
              >
                Buy it Now
              </span> -->
              <el-tooltip v-if="showOneClickOrder" class="item" effect="dark" :content="tipContent" placement="top-start">
                <!-- 没下过vilocal订单 且 这个品牌的vilocal状态不是已完成的就可以点击 -->
                <span
                  v-if="!isExitsViLocalOrder && collectionBrandVilocalStatus !==2"
                  class="btn add-btn top-btn"
                  style="
                    border: 1px solid #F3E93D;
                    background-color: #F3E93D;
                    color: #262613;
                    margin-right:10px;
                  "
                  @click="oneClickOrder"
                >
                  Get ViLocal Order
                </span>
                <span
                  v-else
                  class="btn add-btn top-btn"
                  style="
                    border: 1px solid #B9B9B9;
                    background-color: #B9B9B9;
                    color: #FFFFFF;
                    margin-right:10px;
                    cursor:auto;
                  "
                  @click="oneClickOrder"
                >
                  Get ViLocal Order
                </span>
              </el-tooltip>
              <span  v-if="showOneClickOrder && (isExitsViLocalOrder || collectionBrandVilocalStatus ===2)" class="mobile-tips">{{tipContent}}</span>
              <span
                v-if="showAddToCart && !unAvailableSku"
                class="btn add-btn top-btn"
                style="
                  border: 1px solid #000;
                  background-color: #262b2f;
                  color: #fff;
                "
                @click="addCart"
              >
                Add <span v-if="login">${{totalPrice}}</span> to Cart
              </span>
            </div>

            <!-- 库存不足 -->
            <div v-if="skuStatus=='0'">
              <div style="font-size: 12px;color: #5D5D5D;">This item is temporarily out of stock，restock by {{restockDate | datefmt('L')}}</div>
              <div
                class="btn add-btn"
                style="margin-top: 8px; border: 1px solid #000;background-color: #5D5D5D; color: #fff;cursor: not-allowed;">
               Out of Stock
              </div>
            </div>

            <div class="m-ships-from">
              Fulfills orders within {{queryData.logisticsEfficiency}} days
            </div>
            <!-- 移动端适配 -->
<!--            <div class="imstyle-promotions-mobile" v-if="brandShippingFreePrice && brandShippingFreePrice!=''">-->
<!--              <el-divider></el-divider>-->
<!--              {{collectionBrandName}} Promotions-->
<!--              <br/>-->
<!--              <div class="free-shipping-container">-->
<!--&lt;!&ndash;                <img  class="free-shipping-icon" src="../../assets/img/tag-orange.png">&ndash;&gt;-->
<!--                &lt;!&ndash; <div class="free-shipping-info">Free shipping on orders over ${{ Number.parseFloat(brandShippingFreePrice).toFixed(2)}}+</div> &ndash;&gt;-->
<!--              </div>-->
<!--            </div>-->
            <div class="ships-free">
              <span v-if="firstOrder" class="free-first-order">Free Shipping on Opening Order</span>
              <div class="m-title" v-if="collectionBrandId !== '' && collectionBrandId !== null">
                <div class="m-title-logo">
                 <img
                  :src="collectionBrandLogoUrl"
                  style="
                    height: 45px;
                    width: 45px;
                    float: left;
                    border: 1px solid #e6e6e6;
                    border-radius: 50%;
                  "
                />
                </div>
                <div class="m-title-text" style="position: relative;top: -10px;">
                  <div>
                    <a
                      href="javascript:void(0)"
                      @click="gotoBrand"
                      style="
                        font-size: 16px;
                        color: #262b2f;
                        font-weight: 500;
                        cursor: pointer;
                        font-family:Satoshi-Medium;
                        text-decoration: none;
                      "
                      >{{ collectionBrandName }}</a
                    >
                  </div>

                </div>
                <!-- 评分区 begin-->
                <div class="total-reviews" v-if="queryData['rating']" @click="showCollection=!showCollection">
                  <el-rate
                    v-model="queryData['rating']"
                    disabled
                    :allowHalf="true"
                    style="width: 80px;"
                    :colors="colors"
                    disabled-void-color="#000"
                    disabled-void-icon-class="el-icon-star-off"
                    text-color="#262B2F">
                  </el-rate>
                  <span class="ratingStr">{{queryData['ratingStr']}}</span>
                  <i class="el-icon-arrow-down"></i>
                  <div class="rating-collection" v-if="showCollection" ref="ratingCollection" >
                    <p>
                      <span>Product Quality</span>
                      <el-rate v-model="queryData['descriptionRating']" disabled  :allowHalf="true"  :colors="colors"  disabled-void-color="#000" disabled-void-icon-class="el-icon-star-off" text-color="#262B2F">
                      </el-rate>
                      <span class="rating">{{queryData['productQuality']}}</span>
                    </p>
                    <p>
                        <span> Brand Service</span>
                      <el-rate v-model="queryData['serviceRating']" disabled  :allowHalf="true"  :colors="colors"  disabled-void-color="#000" disabled-void-icon-class="el-icon-star-off" text-color="#262B2F" >
                      </el-rate>
                      <span class="rating">{{queryData['brandServiceStr']}}</span>
                    </p>
                    <p>
                      <span> Logistics Rating</span>
                        <el-rate v-model="queryData['logisticsRating']" disabled  :allowHalf="true" :colors="colors"  disabled-void-color="#000" disabled-void-icon-class="el-icon-star-off"  text-color="#262B2F">
                      </el-rate>
                      <span class="rating">{{queryData['logisticsRatingStr']}}</span>
                    </p>
                  </div>
                </div>
                <!-- 评分区 end -->
              </div>
              <div v-if="isMobile" class="m-brand-tag">
                <div v-if="queryData['brandIsVilocal'] || salesManager !== '' && salesManager !== null" class="m-brand-tag-top">
                  <div v-if="queryData['brandIsVilocal']" class="brand-vilocal">ViLocal</div>
                  <el-tag  v-if="salesManager !== '' && salesManager !== null"  type="danger">Top Brand</el-tag>
                </div>
                <div v-if="collectionBrandId !== '' && collectionBrandId !== null && queryData.collectionBrandSellingPoint && isMobile" >({{queryData.collectionBrandSellingPoint}})</div>
              </div>
            </div>
<!--            <div class="imstyle-promotions" v-if="brandShippingFreePrice && brandShippingFreePrice!=''">-->
<!--              <el-divider></el-divider>-->
<!--              {{collectionBrandName}} Promotions-->
<!--              <br/>-->
<!--              <div class="free-shipping-container">-->
<!--&lt;!&ndash;                <img  class="free-shipping-icon" src="../../assets/img/tag-orange.png">&ndash;&gt;-->
<!--                &lt;!&ndash; <div class="free-shipping-info">Free shipping on orders over ${{ Number.parseFloat(brandShippingFreePrice).toFixed(2)}}+</div> &ndash;&gt;-->
<!--              </div>-->
<!--            </div>-->

            <!-- 30天退款 PC端 -->
            <div class="return-policy">
              <el-divider></el-divider>
                Return Policy
                <br/>
                <span class="return-policy content">We offer free returns for our customer on the first order based on the conditions:</span>
                <br/>
                <span class="return-policy content">1{{'&#41;'}} Within 60 after placing the order, or within 14 days of receiving the products.</span>
                <br/>
                <span class="return-policy content">2{{'&#41;'}} Only applicable to the first order of each brand, and the refund amount cannot exceed $200.</span>
                <br/>
                <span class="return-policy content">3{{'&#41;'}} Standard products only, customized products, testers, or sample items can’t be returned.</span>
            </div>
            <!-- <span
              style="
                margin-left: 21px;
                background-color: #262b2f;
              "
              class="btn"
            >
              Preorder Inventory
            </span> -->
          </div>

        </div>
      </div>

      <div class="goods-desc-content">
        <el-tabs v-model="tabsKey" @change="changeTabs">
          <el-tab-pane name="1" label="Product Details">
            <!-- 30天退款 mobile -->
            <div class="return-policy-mobile">
                Return Policy
                <br/>
                <br/>
                <span class="return-policy-mobile content">We offer free returns for our customer on the first order based on the conditions:</span>
                <br/>
                <span class="return-policy-mobile content">1{{'&#41;'}} Within 60 after placing the order, or within 14 days of receiving the products.</span>
                <br/>
                <span class="return-policy-mobile content">2{{'&#41;'}} Only applicable to the first order of each brand, and the refund amount cannot exceed $200.</span>
                <br/>
                <span class="return-policy-mobile content">3{{'&#41;'}} Standard products only, customized products, testers, or sample items can’t be returned.</span>
            </div>
            <br/>
            <ProductHtml v-if="descInfo" style="width:100%" :descInfo="descInfo"/>
          </el-tab-pane>
          <el-tab-pane
            name="2"
            label="Specification"
            style="background: #ffffff; width: 100%; height: 100vh"
            class="specification"
          >

<!--            <template v-for="(obj, i) in skuParamArr">
              <div class="param-body" v-for="(pArr, key, j) in obj">
                <div class="param-title">
                  <div class="param-title-1">{{ key }}</div>
                  <div class="param-title-2"></div>
                </div>
                <div class="param-content" v-for="(value, k2) in pArr">
                  <div class="param-content-1">{{ value.snparameterDesc }}</div>
                  <div class="param-content-2">{{ value.snparameterVal }}</div>
                </div>
              </div>
            </template>-->
           <p style="line-height: 30px;">
             <strong>SPU id:</strong>
             <span>{{id}}</span>
           </p>
           <p style="line-height: 30px;">
             <strong>SKU id:</strong>
             <span>{{vdSku}}</span>
           </p>
<!--           <p style="line-height: 30px;">
             <strong>SKU code:</strong>
             <span>{{skuCode}}</span>
           </p>-->
           <p style="line-height: 30px;">
             <strong>Weight:</strong>
             <span>{{weight}}{{unit}}</span>
           </p>
           <p style="line-height: 30px;">
             <strong>Dimensions:</strong>
             <span>{{dimensions}}</span>
           </p>
           <p style="line-height: 30px;">
             <strong>Case size:</strong>
             <span>{{goodCase}}</span>
           </p>

          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- 2.2.0 部分 start -->

    <!-- 品牌推荐部分 -->
    <div ref="brandRecommendDiv">
      <brand-recommend-vue ref="brandRecommend" :queryData="queryData" :isMobile="isMobile" :isIpad="isIpad"/>
    </div>
    <!-- More Choices部分 -->
    <div ref="moreRecommendDiv">
      <more-recommend-vue ref="moreRecommend" :queryData="queryData" :isMobile="isMobile" :isIpad="isIpad" />
    </div>
    <!-- 浏览记录部分 -->
    <div ref="recentlyViewedDiv">
      <recently-viewed-vue ref="recentlyViewed" :queryData="queryData" :isMobile="isMobile" :isIpad="isIpad"/>
    </div>
    <!-- 2.2.0 部分 end -->
    <!-- vilocal 专区第四栏目(未登录状态下显示) -->
    <div class="vilocal-zone-main4" id="sign-up" v-if="!login">
      <div  class="vilocal-zone-main1-form-container">
        <div class="main1-form-title">Join us for the latest ViLocal Brand And get ViLocal Brand 100% discount</div>
        <div class="vilocal-zone-main1-form-content">
          <el-form :model="registerForm" ref="registerForm" :inline="!isMobile" :rules="rules" class="vilocal-zone-main1-form">
            <el-form-item prop="email">
              <div class="required-icon">*</div>
              <el-input class="email-input-main1" v-model="registerForm.email" placeholder="Business Email"
                oninput="if(value){value=value.toLowerCase()}" onblur="if(value){value=value.trim()}"></el-input>
            </el-form-item>
            <div v-if="isMobile" style="display: inline-block;">
              <el-row :gutter="10">
                <el-col :span="11">
                  <el-form-item label-position="right" class="flex cust-form-item cust-form-item2" prop="phone">
                    <div class="phone-div">
                      <el-select class="code-input-main1" v-model="registerForm.code" filterable placeholder="+ Country Code"
                        @change="codeChange">
                        <template slot="empty">
                          <p style="display:none">no data</p>
                        </template>
                        <el-option v-for="(item, index) in options" :label="item.text" :value="item" :key="index">
                          <span style="float: left">{{ item.text }}</span>
                          <span style="float: right; color: #8492a6; font-size: 13px">{{
                            item.value
                          }}</span>
                        </el-option>
                      </el-select>
                      <div class="divider"></div>
                      <div class="required-icon-phone">*</div>
                      <el-input class="phone-input-main1" v-model="registerForm.phone" placeholder="Phone"
                        @input="changePhone"></el-input>
                    </div>

                  </el-form-item>
                </el-col>
                <el-col :span="13">
                  <el-form-item prop="onlineShopType">
                  <div class="required-icon"  v-if="isMobile" >*</div>
                    <el-select v-model="registerForm.onlineShopType" class="store-type-input-main1" placeholder="Store Type">
                      <el-option v-for="(item, index) in storeType" :key="item.textTitle" :label="item.textTitle"
                        :value="index"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <el-form-item v-if="!isMobile" class="flex cust-form-item cust-form-item2" prop="phone">
              <div class="phone-div">
                <el-select class="code-input-main1" v-model="registerForm.code" filterable placeholder="+ Country Code"
                  @change="codeChange">
                  <template slot="empty">
                    <p style="display:none">no data</p>
                  </template>
                  <el-option v-for="(item, index) in options" :label="item.text" :value="item" :key="index">
                    <span style="float: left">{{ item.text }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">{{
                      item.value
                    }}</span>
                  </el-option>
                </el-select>
                <div class="divider"></div>
                <div class="required-icon-phone" style="{left: 80px;}">*</div>
                <el-input class="phone-input-main1" v-model="registerForm.phone" placeholder="Phone"
                  @input="changePhone"></el-input>
              </div>
            </el-form-item>
            <el-form-item prop="onlineShopType" v-if="!isMobile">
            <div class="required-icon">*</div>
              <el-select v-model="registerForm.onlineShopType" class="store-type-input-main1" placeholder="Store Type">
                <el-option v-for="(item, index) in storeType" :key="item.textTitle" :label="item.textTitle"
                  :value="index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="storeName">
            <div class="required-icon">*</div>
              <el-autocomplete popper-class="my-autocomplete" v-model="registerForm.storeName" class="store-name-input-main1"
                :trigger-on-focus="false" :fetch-suggestions="getGoogleMap" placeholder="Store Name"
                @select="handleSelect">
                <template slot-scope="{ item }">
                  <span><img class="sit_img" src="https://shopvidi.oss-cn-beijing.aliyuncs.com/shopvidi-1.4.1/google1.png"
                      alt=""></span>
                  <span>{{ item.label }}</span>
                  <span style="color:gray;margin-left:2px"> , {{ item.address }}</span>
                </template>
              </el-autocomplete>
            </el-form-item>

            <el-form-item prop="storeAddress">
            <div class="required-icon"  v-if="!isMobile" style="top:0;">*</div>
              <el-input v-if="!isMobile" class="store-address-input-main1" v-model="registerForm.storeAddress"
                placeholder="Store Address" type="textarea" :rows="4" resize="none"></el-input>
                <div class="required-icon"  v-if="isMobile" >*</div>
              <el-input v-if="isMobile" class="store-address-input-main1" v-model="registerForm.storeAddress"
                placeholder="Store Address">
              </el-input>
            </el-form-item>

            <el-form-item prop="interestedCategory">
              <div class="required-icon">*</div>
              <el-select class="interested-category-input-main1" v-model="registerForm.interestedCategory" ref="interestedCategorySelect"
                placeholder="Interested Category" multiple :multiple-limit="5" @change="changeCategory" >
                <el-option v-for="(item, index) in vilocalSecondClassCategories" :key="item.storeTypeName" :label="item.storeTypeName"
                        :value="index"></el-option>
                <el-option key="clear" value="-1" class="not-find-option">
                  <span>Can’t find your Category? <span style="text-decoration: underline;text-underline-offset: 3px; text-underline: #333333;">Click Here</span></span>
                </el-option>
              </el-select>
            </el-form-item>

          </el-form>
        </div>
        <div class="vilocal-zone-main1-button" v-loading="loading" @click="submit('registerForm')" >Get free trial sales NOW!</div>
      </div>
    </div>
    <el-dialog :show-close="true"
               class="creae-cate-info"
               :visible.sync="createCategoryVisible"
               destroy-on-close
               :width="IS_MOBILE?'100%':'355px'"
               :close-on-click-modal="true">
      <p>Interested Category</p>
      <el-input placeholder="Enter Interested Category" v-model="newInterestedCategory"></el-input>
      <div class="submit" @click="createInterestedCategory">Submit</div>
    </el-dialog>
    <home-footer />
    <!-- 添加产品主题表单 -->
    <el-dialog
      :visible.sync="showThemeForm"
      title="Add Theme"
      class="dialog-item add-dialog-item detail-dialog"
      append-to-body
      @close="themeName = ''"
    >
            <span slot="footer" class="dialog-footer">
              <el-button @click="saveTheme(false)">Cancel</el-button>
              <el-button
                class="submit-btn"
                @click="saveTheme(true)"
                :loading="saveLoading"
              >
                Save
              </el-button>
            </span>
      <el-input
        v-model="themeName"
        placeholder="Please enter a theme name"
      />
    </el-dialog>

    <el-dialog
      title="Tips"
      :visible.sync="confimDeleteVis"
      class="dialog-item add-dialog-item detail-dialog"
      append-to-body
    >
      <span>Are you sure to delete!</span>
      <span slot="footer" class="dialog-footer">
              <el-button @click="confimDeleteVis = false">Cancel</el-button>
              <el-button
                class="submit-btn"
                @click="deleteItemMethods"
                :loading="deleteItemLoading"
              >Submit</el-button
              >
            </span>
    </el-dialog>
    <el-dialog
      title="Add to Imports List"
      :visible.sync="visible"
      class="dialog-item add-dialog-item detail-dialog"
    >
      <el-form :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <el-form-item label="Products theme">
          <el-select
            filterable
            v-model="selTheme"
            placeholder=""
            style="width: 180px"
            @change="handleChangeByTheme"
          >
            <el-option
              :value="item.value"
              :key="item.value"
              :label="item.label"
              v-for="(item, index) in themeArr"
            >
              <span style="float: left"> {{ item.label }}</span>
              <span
                style="float: right; margin-right: 10px"
                @click="confimDelete(item)"
              >
                      <i class="el-icon-delete"></i>
                    </span>
            </el-option>
          </el-select>
          <span class="add-theme" @click="openThemeForm"
          >+ Add Theme</span
          >
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
              <el-button @click="handleOk(true)"
              >Skip and import list</el-button
              >
              <el-button
                class="submit-btn"
                :loading="subLoading"
                @click="handleOk(false)"
              >
                Submit
              </el-button>
            </span>
    </el-dialog>
    <!-- 物流弹框 -->
    <el-dialog
      class="dialog-item detail-dialog"
      :visible.sync="showShippingMethod"
      title="Shipping Method"
    >
      <span slot="footer" class="dialog-footer">
        <el-button @click="saveShippingMethod(false)">Cancel</el-button>
        <el-button class="submit-btn" @click="saveShippingMethod(true)"
          >Save</el-button
        >
      </span>
      <!-- 发货地，在商品的接口已经返回了，需要组装一个List进行显示，默认会选择第一个，当切换Sku后需要获取该Sku可以发货的仓库 -->
      <el-form ref="form" label-width="120px">
        <el-form-item label="Shipping From:">
          <el-select
            v-model="shippingFromValue"
            filterable
            placeholder="Select Shipping From"
            style="width: 200px"
            @change="handleChangeShoppingFrom"
          >
            <el-option
              :value="item.value"
              :key="item.value"
              :label="item.label"
              v-for="item in startCountryCodeList"
            >
              {{ item.label }}
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Ship to:">
          <el-select
            default-value="US"
            v-model="shippingToValue"
            filterable
            placeholder="Select Ship to"
            style="width: 200px"
            @change="handleChange"
          >
            <el-option
              :value="item.code"
              :key="item.code"
              :label="item.nameEn"
              v-for="item in countryCodeList"
            >
              {{ item.nameEn }}
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="shopMethod">
        The selected shipping method is shown in the price list. This is
        provided by ShopVidi based on your chosen country/region and standard
        delivery method (e.g. ePacket). Note: This is the cost of sending a
        single item and does not include advanced or bulk sending options.
      </div>
      <el-table
        v-loading="tableLoading"
        highlight-current-row
        @current-change="onSelectChange"
        :data="shopMethodList"
        style="width: 100%"
      >
        <el-table-column
          prop="logisticsName"
          label="Shipping Method"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="arrivalTime"
          label="Delivery Time Estimate(Business Days)"
          align="center"
          width="300px"
        >
        </el-table-column>
        <el-table-column prop="postage" label="Shipping Cost" align="center">
          <template slot-scope="scope">
            <span>{{ "$" + scope.row.postage }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { getAction, postAction, deleteAction } from '@/api/manage.js'
import Breadcrumb from '../components/breadcrumb.vue'
import homeFooter from '../home/components/homeFooter.vue'
import code from '@/components/code.js'
import Vue from 'vue'
import PaPay from '../checkout/pa-pay.vue'
import {buryingPoint} from '../../utils/log'
import { forceInitWebSocket } from '../../utils/ws'
import brandRecommendVue from './recommend/brand-recommend.vue'
import moreRecommendVue from './recommend/more-recommend.vue'
import recentlyViewedVue from './recommend/recently-viewed.vue'
import ProductHtml from '../../components/product-html.vue'

export default {
  components: {
    homeFooter,
    Breadcrumb,
    PaPay,
    brandRecommendVue,
    moreRecommendVue,
    recentlyViewedVue,
    ProductHtml
  },
  data() {
    return {
      abbrStyle: {},
      brandRecommendExposure: false,
      moreChoicesExposure: false,
      recentlyViewedExposure: false,
      showOneClickOrder: false, // 是否显示一键下单按钮 默认不显示
      showAddToCart: false, // 是否显示加购按钮 默认不显示
      specialBrandList: [
        '1550447824426545154',
        '1648152299865436161',
        '1673945548764758018',
        '1683739410832121858'
      ], // 特殊品牌
      isExitsViLocalOrder: false,
      bottomBtnFlag: true,
      interestedCategoryArr: [],
      emailLimit: '',
      newCountryCode: '',
      options: [],
      storeType: [
        {
          img: 'https://shopvidi.oss-cn-beijing.aliyuncs.com/homepage-img/shopvidi/Faire.com%20%E2%80%94%20The%20Online%20Wholesale%20Marketplace%20%20Store%402x.png',
          textTitle: 'Brick & Mortar Store',
          textSubtitle: 'I sell from my own retail storefront.'
        },
        {
          img: 'https://shopvidi.oss-cn-beijing.aliyuncs.com/homepage-img/shopvidi/Faire.com%20%E2%80%94%20The%20Online%20Wholesale%20Marketplace%20%20Store%402x%20%281%29.png',
          textTitle: 'Brick & Mortar and Online Store',
          textSubtitle: 'I sell from both retail stores and online stores.'
        },
        {
          img: 'https://shopvidi.oss-cn-beijing.aliyuncs.com/homepage-img/shopvidi/Faire.com%20%E2%80%94%20The%20Online%20Wholesale%20Marketplace%20%20Store%402x%20%282%29.png',
          textTitle: 'Online Boutique Store',
          textSubtitle: 'I only sell from my own unique website.'
        },
        {
          img: 'https://shopvidi.oss-cn-beijing.aliyuncs.com/homepage-img/shopvidi/Faire.com%20%E2%80%94%20The%20Online%20Wholesale%20Marketplace%20%20Store%402x%20%283%29.png',
          textTitle: 'Pop-up Store',
          textSubtitle:
            'I sell from a shared marketplace as a vendor, or at events.'
        },
        {
          img: 'https://shopvidi.oss-cn-beijing.aliyuncs.com/homepage-img/shopvidi/Faire.com%20%E2%80%94%20The%20Online%20Wholesale%20Marketplace%20%20Store%402x%20%284%29.png',
          textTitle: 'Social Media',
          textSubtitle: 'I only sell products on other channels'
        }
      ],
      onlyEmailFlag: false,
      onlyPhoneFlag: false,
      loading: false,
      rules: {
        email: [
          { required: true, message: 'Please enter the email', trigger: 'blur' },
          { validator: this.checkEmail, trigger: 'blur'}
        ],
        onlineShopType: [
          { required: true, message: 'Please select a store type', trigger: 'change' }
        ],
        phone: [
          { validator: this.checkPhone, trigger: 'change'}
        ],
        storeName: [{ trigger: ['blur', 'change'], validator: this.checkStoreName }],
        storeAddress: [{ trigger: ['blur', 'change'], validator: this.checkStoreAddress }],
        interestedCategory: [
          { required: true, message: 'Please enter the interested category', trigger: 'change'}
        ]
      },
      vilocalSecondClassCategories: [],
      newInterestedCategory: '',
      createCategoryVisible: false,
      registerForm: {
        email: '',
        onlineShopType: '',
        phone: '',
        code: '+1(US)',
        storeAddress: '',
        storeName: '',
        countryCode: 'US',
        interestedCategory: []
      },
      tipContent: 'Includes all products for a $0.00 Free Trial',
      brandShippingFreePrice: null,
      firstOrder: true,
      queryData: {},
      defaultIndex: 0,
      imgWidth: 0,
      imgHeight: 0,
      seoUrl: '',
      product_detail_id: '',
      goodsStatus: '',
      deleteItemLoading: false,
      deleteItem: '',
      confimDeleteVis: false,
      subLoading: false,
      form: {
        menuHref: '', // 菜单连接
        menuContent: '', // 菜单名称
        menuList: [] // 导航集合
      },
      showThemeForm: false, // 是否显示选品主题
      saveLoading: false,
      userName: '',
      isLogin: false,
      userImg: '',
      tableLoading: false, // 物流表格loading
      tempSelectedRowKeys: [], // 临时的表格行集合
      selectedRowKeys: [],
      shoppingMethod: '',
      tempShippingFromText: '',
      shopMethodList: [], // 物流列表数据
      startCountryCodeList: [],
      showShopMethodDefault: true,
      days: '8-15days', // 运输时长
      tempShippingFromValue: '', // 临时发货值
      tempShippingToValue: '', // 临时收货值
      tempShippingToText: '', // 临时收货显示
      shippingFromValue: '', // 发货地值
      shippingToValue: 'US', // 收货地值
      shippingFromText: '——', // 发货地显示
      shippingToText: '——',
      showan: false,
      showShippingMethod: false, // 是否显示物流弹框
      countryCodeList: code.countryCodeList,
      tabsKey: '1',
      menuObject: {}, // 左侧集合
      themeArr: [],
      themeName: '',
      visible: false,
      selTheme: undefined,
      title: '',
      id: undefined,
      goodsTitle: '',
      goodCase: '',
      sort: 0,
      descInfo: '',
      preImg: '', // 预览图
      price: 0, // 成本价
      netPrice: '', // 建议零售价
      aboutProfit: '', // 约赚
      discountPrice: '', // 折扣价
      freight: '10.99',
      weight: 1, // 重量
      num: 1,
      isActive0: -1,
      isActive1: -1,
      isActive2: -1,
      isActive3: -1,
      isActive4: -1,
      isActive5: -1,
      stockNum: 1, // 库存
      skuInfo: '', //当前选中的sku信息
      skuId: '', //
      vdSku: '', //
      skuCode: '', //
      skuStatus: '', //
      restockDate: '', //
      totalPrice: 0,
      dimensions: '', // 尺寸
      unit: 'g',
      skuAttributeMap: null,
      skuAttStrWithSkuIdMap: new Map(), // sku特征id字符串与skuId Map
      skuIdWithSkuMap: new Map(), // skuId与对象map
      parentIdWithSonListMap: new Map(), // 父类ID与后续List map
      token: '',
      skuParamMap: new Map(), // (skuId_[{主体:Array(obj)}])
      skuParamArr: [], // ([{主体:Array(obj)}])
      feNetWork: '',
      feShopvidiCom: '',
      beNetWrok: '',
      fileDetails: [],
      collectionBrandId: '',
      collectionBrandLogoUrl: '',
      collectionBrandName: '',
      collectionBrandSeoUrl: '',
      collectionBrandVilocalStatus: 1,
      salesManager: '',
      selSkuStr: undefined, // 选择的sku信息
      url: {
        detailUrl: 'tsgoods/tsGoodsInfo/queryById', // 商品详情
        storeDetailUrl: '/store/tsStoreGoodsInfo/queryById', // 店铺商品详情

        skuCharacterUrl: 'tsgoods/tsGoodsInfo/sku_character', // 特征url
        storeskuCharacterUrl: 'store/tsGoodsInfo/sku_character', // 店铺特征url

        storeSkuParamUrl: 'store/tsStoreGoodsInfo/sku_param', // 参数url
        skuParamUrl: 'tsgoods/tsGoodsInfo/sku_param' // 店铺参数url
      },
      attObj: {
        att0Flag: false,
        att1Flag: false,
        att2Flag: false,
        att3Flag: false,
        att4Flag: false,
        att5Flag: false,
        att0Name: '',
        att1Name: '',
        att2Name: '',
        att3Name: '',
        att4Name: '',
        att5Name: '',
        disName: '',
        changeCurIdx: '',
        att0Arr: [],
        att1Arr: [],
        att2Arr: [],
        att3Arr: [],
        att4Arr: [],
        att5Arr: [],
        attV0: '',
        attV1: '',
        attV2: '',
        attV3: '',
        attV4: '',
        attV5: ''
      },
      showReailPrice: false,
      showWholesalePrice: false,
      firstSelSku: false, // 第一次切换sku
      plusContainer: localStorage.getItem('showOnHold') === 'true',
      unAvailableSku: false, // 选中的SKU是否存在
      showCollection: false,
      colors: ['#000000', '#000000', '#000000'],
      vilocalTypeTips: ''
    }
  },
  computed: {
    isMod() {
      return navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
    },
    dataTitle() {
      return `${this.goodsTitle}|ShopVidi.com`
    },
    isMobile() {
      const isMob = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return isMob
    },
    isIpad() {
      const isPad = navigator.userAgent.toLowerCase().match(/ipad/i)
      return isPad
    }
  },
  watch: {
    goodsTitle: {
      handler(n, o) {
        document.title = this.goodsTitle + '|ShopVidi.com'
        document.querySelector('meta[name="keywords"]').setAttribute('content', this.goodsTitle)
        document.querySelector('meta[name="description"]').setAttribute('content', this.goodsTitle + ',Free net 60 term, Low minimum spend | Shopvidi')
      }
    },
    menuObject: {
      handler(n, o) {
        // this.loadData(n)
      },
      deep: true
    },

    $route(to, from) {
      // this.getGoodId()
      if (to.name === 'goods-detail') {
        const reqUrl = this.$route.query.type
          ? this.url.storeDetailUrl
          : this.url.detailUrl
        const characterUrl = this.$route.query.type
          ? this.url.storeskuCharacterUrl
          : this.url.skuCharacterUrl
        const paramUrl = this.$route.query.type
          ? this.url.storeSkuParamUrl
          : this.url.skuParamUrl
        this.loadDetail(reqUrl, characterUrl, paramUrl)
        // this.loadSkuCharacterUrl(characterUrl, this.product_detail_id)
        // this.loadParam(paramUrl, this.product_detail_id)
      }
      if (to.fullPath !== from.fullPath) {
        // 监听路由参数是否变化
        this.menuObject = { ...this.menuObject, ...{} }
        // this.judgeItem()
      }
    },
    price(n, j) {
      this.totalPrice = (this.price * this.num)
      this.totalPrice = this.totalPrice.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
    },
    num (n, j) {
      if (!n) {
        return false
      }
      this.totalPrice = (this.price * this.num)
      this.totalPrice = this.totalPrice.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
    },
    attObj: {
      // 此处只需要监听sku属性对象变化即可，无需知道具体值发生变化。
      handler (val, oldVal) {
        let tmpArr = []
        for (let k in val) {
          if (val[k] != '' && k.indexOf('V') > 0) {
            tmpArr.push(val[k])
          }
        }
        // 赋值后续下拉框
        let sonList = this.parentIdWithSonListMap.get(val.disName)
        sonList = !sonList ? [] : sonList
        switch (val.changeCurIdx) {
          case 0:
            if (val.att1Flag) {
              this.isActive1 = -1
              this.isActive2 = -1
              val.att1Arr = sonList
              // TODO haoyuanw  add 2021-12-20 如果sonList 有值要选中第一个 start
              if (val.att1Arr && val.att1Arr.length > 0) {
                let dataValue = this.attObj.att1Arr[0].value
                this.attObj.disName = dataValue + '_' + this.attObj.att1Name
                this.attObj.changeCurIdx = 1
                this.isActive1 = 0
                this.attObj.attV1 = dataValue
              }
              // TODO haoyuanw  add 2021-12-20 如果sonList 有值要选中第一个 end
            }
            break
          case 1:
            if (val.att2Flag) {
              this.isActive2 = -1
              this.isActive3 = -1
              val.att2Arr = sonList
              // TODO haoyuanw  add 2021-12-20 如果sonList 有值要选中第一个 start
              if (val.att2Arr && val.att2Arr.length > 0) {
                let dataValue = this.attObj.att2Arr[0].value
                this.attObj.disName = dataValue + '_' + this.attObj.att2Name
                this.attObj.changeCurIdx = 2
                this.isActive2 = 0
                this.attObj.attV2 = dataValue
              }
              // TODO haoyuanw  add 2021-12-20 如果sonList 有值要选中第一个 end
            }
            break
          case 2:
            if (val.att3Flag) {
              this.isActive3 = -1
              this.isActive4 = -1
              val.att3Arr = sonList
              // TODO haoyuanw  add 2021-12-20 如果sonList 有值要选中第一个 start
              if (val.att3Arr && val.att3Arr.length > 0) {
                let dataValue = this.attObj.att3Arr[0].value
                this.attObj.disName = dataValue + '_' + this.attObj.att3Name
                this.attObj.changeCurIdx = 3
                this.isActive3 = 0
                this.attObj.attV3 = dataValue
              }
              // TODO haoyuanw  add 2021-12-20 如果sonList 有值要选中第一个 end
            }
            break
          case 3:
            if (val.att4Flag) {
              this.isActive4 = -1
              this.isActive5 = -1
              val.att4Arr = sonList
              // TODO haoyuanw  add 2021-12-20 如果sonList 有值要选中第一个 start
              if (val.att4Arr && val.att4Arr.length > 0) {
                let dataValue = this.attObj.att4Arr[0].value
                this.attObj.disName = dataValue + '_' + this.attObj.att4Name
                this.attObj.changeCurIdx = 4
                this.isActive4 = 0
                this.attObj.attV4 = dataValue
              }
              // TODO haoyuanw  add 2021-12-20 如果sonList 有值要选中第一个 end
            }
            break
          case 4:
            if (val.att5Flag) {
              this.isActive5 = -1
              val.att5Arr = sonList
              // TODO haoyuanw  add 2021-12-20 如果sonList 有值要选中第一个 start
              if (val.att5Arr && val.att5Arr.length > 0) {
                let dataValue = this.attObj.att5Arr[0].value
                this.attObj.disName = dataValue + '_' + this.attObj.att5Name
                this.attObj.changeCurIdx = 5
                this.isActive5 = 0
                this.attObj.attV5 = dataValue
              }
              // TODO haoyuanw  add 2021-12-20 如果sonList 有值要选中第一个 end
            }
            break
        }

        this.selSkuStr = tmpArr.join('—')

        let skuId = this.skuAttStrWithSkuIdMap.get(this.selSkuStr)
        if (skuId === null || skuId === '' || skuId === undefined) {
          this.selSkuStr = tmpArr.reverse().join('—')
        }
        this.switchSku()
        this.switchSkuParam()
      },
      deep: true // true 深度监听
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.brandRecommendExposureMethod)
    window.removeEventListener('scroll', this.moreChoicesExposureMethod)
    window.removeEventListener('scroll', this.recentlyViewedExposureMethod)
  },
  created() {
    window.addEventListener('scroll', this.brandRecommendExposureMethod)
    window.addEventListener('scroll', this.moreChoicesExposureMethod)
    window.addEventListener('scroll', this.recentlyViewedExposureMethod)
    this.$ls.remove('vilocalBrand')
    this.getIsExitsViLocalOrder()
    // TODO haoyuanw 20220409 hotfix 查询在不登录的情况下显示哪个价格
    this.getSimpleConfiguration()
    this.getPhoneAndCountry()
    this.getStoreType()
    this.loadConfigurationEmal()
    window.scrollTo(0, 0)
    // this.getGoodId()
    this.countryCodeList = this.sortList()
    this.seoUrl = this.$route.params.url
    // TODO haoyuanw add mixpanel 商品页
    // eslint-disable-next-line no-undef
    mixpanel.track('v_product_details', { product_id: this.product_detail_id })
    this.beNetWrok = 'http://localhost:8080/thalesmart/'
    if (window.location.origin.indexOf('shopvidi.com') > -1) {
      this.feNetWork = 'https://p.shopvidi.com'
      this.feShopvidiCom = 'https://www.shopvidi.com'
      this.beNetWrok = 'https://p-api.shopvidi.com/shopvidi-en/'
    } else if (window.location.origin.indexOf('manage-ui') > -1) {
      this.feNetWork = 'https://test-thalesmart-manage-ui.hupofintech.com'
      this.feShopvidiCom = 'https://test-thalesmart-manage-ui2.hupofintech.com'
      this.beNetWrok =
        'https://api-test.shopvidi.com/thalesmart/'
    } else if (window.location.origin.indexOf('localhost') > -1) {
      this.feNetWork = 'http://localhost:3000'
      this.feShopvidiCom = 'http://localhost:8080'
    } else if (window.location.origin.indexOf('192') > -1) {
      this.feNetWork = window.location.origin
      this.feShopvidiCom = window.location.origin.replace('3000', '8080')
    }

    if (this.getParam('flag') == 1) {
      this.form.menuContent = 'Dashboard'
      this.form.menuHref = this.feNetWork
    }
    if (this.getParam('flag') == 2) {
      this.form.menuContent = 'Products'
      this.form.menuHref = this.feNetWork + '/goods/index'
    }
    if (this.getParam('flag') == 3) {
      this.form.menuContent = 'Import List'
      this.form.menuHref = this.feNetWork + '/goods/import/list'
    }
    if (this.getParam('flag') == 4) {
      this.form.menuContent = 'My Products'
      this.form.menuHref = this.feNetWork + '/goods/my/list'
    }
    if (this.getParam('flag') == 11) {
      this.form.menuContent = 'Home'
      this.form.menuHref = this.feShopvidiCom
    }
    if (this.getParam('flag') == 13) {
      this.form.menuContent = 'Home'
      this.form.menuHref = this.feShopvidiCom
    }
    if (this.getParam('flag') == 14) {
      this.form.menuContent = 'Home'
      this.form.menuHref = this.feShopvidiCom
      const menuObject = {
        id: '',
        path:
          this.feShopvidiCom +
          '/brand?id=' +
          this.$route.query.brandId +
          '&value=' +
          this.getParam('value'),
        title: this.getParam('value')
      }
      this.form.menuList.push(menuObject)
    }
    if (this.getParam('flag') == 12) {
      this.form.menuContent = 'Home'
      this.form.menuHref = this.x
      // 每一级要有id，path，和title
      const menuObject = {
        id: '',
        path: this.feShopvidiCom + '/search?value=' + this.getParam('keyWords'),
        title: this.getParam('keyWords')
      }
      this.form.menuList.push(menuObject)
    }

    this.token = this.getToken()

    const reqUrl = this.$route.query.type
      ? this.url.storeDetailUrl
      : this.url.detailUrl
    const characterUrl = this.$route.query.type
      ? this.url.storeskuCharacterUrl
      : this.url.skuCharacterUrl
    const paramUrl = this.$route.query.type
      ? this.url.storeSkuParamUrl
      : this.url.skuParamUrl
    this.loadDetail(reqUrl, characterUrl, paramUrl)
    // this.loadThemeList()
    document.title = this.dataTitle

    // this.token ? () : null
    if (this.token) {
      getAction('/order/check/first-order').then((res) => {
        this.firstOrder = res.result
      })
    }

    // document.addEventListener('click', (e) => {
    //   let isClickRatingArea = false
    //   e.path.forEach(o => {
    //     try {
    //       if (o && o.getAttribute('class') && o.getAttribute('class') === 'total-reviews') {
    //         isClickRatingArea = true
    //       }
    //     } catch (e) {
    //     }
    //   })
    //   if (!isClickRatingArea) {
    //     this.showCollection = false
    //   }
    // })

    // console.log(this.$data.queryData)
    // getAction('product/api/v0.2/products/{product_id}')
  },
  methods: {
    brandRecommendExposureMethod() {
      if (this.brandRecommendExposure) {
        return
      }
      // 获取可视窗口的高度。
      const screenHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
      // 获取滚动条滚动的高度
      const scrollTop = document.documentElement.scrollTop
      // 获取元素偏移的高度。就是距离可视窗口的偏移量。
      const offsetTop = this.$refs.brandRecommendDiv.offsetTop
      if (offsetTop - scrollTop <= screenHeight) {
        let profile = 'staging'
        if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
          profile = 'test'
        } else if (process.env.NODE_ENV === 'production') {
          profile = 'prod'
        }
        this.brandRecommendExposure = true
        mixpanel.track(profile + '_recommendation', {products_recommendation: profile + '_brand_more'})
      }
    },
    moreChoicesExposureMethod() {
      if (this.moreChoicesExposure) {
        return
      }
      // 获取可视窗口的高度。
      const screenHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
      // 获取滚动条滚动的高度
      const scrollTop = document.documentElement.scrollTop
      // 获取元素偏移的高度。就是距离可视窗口的偏移量。
      const offsetTop = this.$refs.moreRecommendDiv.offsetTop
      if (offsetTop - scrollTop <= screenHeight) {
        let profile = 'staging'
        if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
          profile = 'test'
        } else if (process.env.NODE_ENV === 'production') {
          profile = 'prod'
        }
        this.moreChoicesExposure = true
        mixpanel.track(profile + '_recommendation', {products_recommendation: profile + '_more_choices'})
      }
    },
    recentlyViewedExposureMethod() {
      if (this.recentlyViewedExposure) {
        return
      }
      // 获取可视窗口的高度。
      const screenHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
      // 获取滚动条滚动的高度
      const scrollTop = document.documentElement.scrollTop
      // 获取元素偏移的高度。就是距离可视窗口的偏移量。
      const offsetTop = this.$refs.recentlyViewedDiv.offsetTop
      if (offsetTop - scrollTop <= screenHeight) {
        let profile = 'staging'
        if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
          profile = 'test'
        } else if (process.env.NODE_ENV === 'production') {
          profile = 'prod'
        }
        this.recentlyViewedExposure = true
        mixpanel.track(profile + '_recommendation', {products_recommendation: profile + '_recently_viewed'})
      }
    },
    checkStoreName(rule, value, callback) {
      if (value) {
        value = value.trim()
        if (value === '') {
          this.registerForm.storeName = ''
          callback(new Error('Please fill in Store Name'))
        } else {
          callback()
        }
      } else {
        callback(new Error('Please fill in Store Name'))
      }
    },
    checkStoreAddress(rule, value, callback) {
      if (value) {
        value = value.trim()
        if (value === '') {
          this.registerForm.storeAddress = ''
          callback(new Error('Please fill in Store Address'))
        } else {
          callback()
        }
      } else {
        callback(new Error('Please fill in Store Address'))
      }
    },
    async getIsExitsViLocalOrder() {
      if (this.login) {
        let userInfoJson = JSON.parse(localStorage.getItem('pro__userInfo'))
        if (userInfoJson && userInfoJson.value.id) {
          getAction('/order/api/v0.2/users/' + userInfoJson.value.id + '/is-exist-vilocal-order').then(response => {
            if (response.success) {
              this.isExitsViLocalOrder = response.result
            } else {
              this.$message.warning(response.message)
            }
          })
        }
      }
    },
    handleInterestedCategories() {
      this.interestedCategoryArr = []
      for (let i = 0; i < this.registerForm.interestedCategory.length; i++) {
        let index = this.registerForm.interestedCategory[i]
        let item = this.vilocalSecondClassCategories[index]
        if (item) {
          this.interestedCategoryArr.push(`${item.id}-${item.storeTypeName}`)
        } else {
          this.interestedCategoryArr.push(`${index}-${index}`)
        }
      }
    },
    submit(type) {
      this.handleInterestedCategories()
      if (this.loading) {
        return
      }
      this.$refs[type].validate(valid => {
        if (valid) {
          if (this.registerForm.email && (this.registerForm.onlineShopType || this.registerForm.onlineShopType === 0) && this.registerForm.phone && this.registerForm.code && this.registerForm.storeName && this.registerForm.storeAddress && this.registerForm.interestedCategory.length > 0 && !this.onlyEmailFlag && !this.onlyPhoneFlag) {
            this.loading = true
            const params = JSON.parse(JSON.stringify(this.registerForm))
            params.phone = this.registerForm.code + '-' + this.registerForm.phone
            params.type = 'vilocal'
            params.userSource = 1
            params.hostId = localStorage.getItem('mac')
            params.interestedCategory = this.interestedCategoryArr
            if (localStorage.getItem('utm_source')) {
              params['utmSource'] = localStorage.getItem('utm_source')
            }
            if (localStorage.getItem('utm_medium')) {
              params['utmMedium'] = localStorage.getItem('utm_medium')
            }
            if (localStorage.getItem('utm_campaign')) {
              params['utmCampaign'] = localStorage.getItem('utm_campaign')
            }
            if (localStorage.getItem('utm_id')) {
              params['utmId'] = localStorage.getItem('utm_id')
            }
            if (localStorage.getItem('utm_term')) {
              params['utmTerm'] = decodeURIComponent(localStorage.getItem('utm_term'))
            }
            if (localStorage.getItem('utm_content')) {
              params['utmContent'] = localStorage.getItem('utm_content')
            }
            console.log(params)
            postAction('/sys/user/register', params).then(response => {
              if (response.success) {
                if (response.result) {
                  this.$ls.set('token', response.result.token)
                  this.$ls.set('userInfo', response.result.userInfo)
                  this.$ls.set('realname', response.result.userInfo.realname)
                  Vue.prototype.login = true
                  // add by cpgu 2023/03/07 begin
                  try {
                    forceInitWebSocket()
                  } catch (e) {
                    // 此处不能影响主业务
                    console.error(e)
                  }
                  // GA 和 FB的 推送
                  gtag('event', 'click', {
                    'event_category': 'successsignup'
                  })
                  fbq('track', 'CompleteRegistration')
                  gtag('event', 'conversion', {'send_to': 'AW-10888618638/3akACMDW880YEI7FjMgo'})
                  let vilocalBrandId = JSON.parse(localStorage.getItem('pro__vilocalBrand'))
                  let userId = response.result.userInfo.id
                  if (vilocalBrandId && vilocalBrandId.value !== null) {
                    // 2.0.8 新增逻辑 如果是注册完成后，不跳转checkout页面了，直接跳转到店铺审核信息页面补充数据
                    // 跳转到店铺审核页面  localStorage.removeItem('pro__vilocalBrand') 这个留着，当离开store-info 再清除
                    postAction(`order/api/v0.2/users/${userId}/vi-local-orders?brand_id=${vilocalBrandId.value}`).then((res) => {
                      if (res.code === 200 && res.result.orderId) {
                        localStorage.removeItem('pro__vilocalBrand')
                        // 2.2.2 注册完毕后，就根据选中的品牌生成订单，然后
                        this.$router.push({path: '/store-info', query: {orderId: res.result.orderId}})
                      }
                    })
                    // postAction(`order/api/v0.2/users/${userId}/vi-local-orders?brand_id=${vilocalBrandId.value}`).then((res) => {
                    //   if (res.code == 200 && res.result.orderId) {
                    //     localStorage.removeItem('pro__vilocalBrand')
                    //     this.$router.push({
                    //       name: 'checkout',
                    //       params: {
                    //         // path: '/shopping-cart',
                    //         orderId: res.result.orderId
                    //         // name: 'Wholesale Bag'
                    //       }
                    //     })
                    //   }
                    // })
                  } else {
                    // window.location.reload()
                    localStorage.setItem('vilocal_url', window.location.href)
                    this.$router.push({name: 'profile', params: {finish: '1'}})
                    window.scrollTo(0, 0)
                  }
                }
              } else {
                this.$message.warning(response.message)
              }
              this.loading = false
            })
          }
        }
      })
      // 因为表单验证通过有问题，没有解决，先保证功能好使
      this.$refs[type].validate(valid => { })
    },
    async getStoreType() {
      let menuData
      if (localStorage.getItem('meauData') == null || localStorage.getItem('meauData') == undefined) {
        let res = await getAction('/tsCategory/tsCateInfo/all-list')
        if (res.success) {
          menuData = res.result
        } else {
          this.$message.warning(res.message)
        }
      } else {
        menuData = JSON.parse(localStorage.getItem('meauData'))
      }
      for (let firstClass of menuData) {
        if (firstClass.name == 'Featured' || firstClass.name == 'collectiontest' || firstClass.cateName == 'collectiontest' || firstClass.cateName == 'Shop By Retailer') {
          continue
        }
        for (let secondClass of firstClass.childrenList) {
          if (secondClass.cateName == 'New Releases') {
            continue
          }
          this.vilocalSecondClassCategories.push({ id: secondClass.id, storeTypeName: secondClass.cateName })
        }
      }
    },
    changeCategory(indxArr) {
      if (indxArr) {
        let index = indxArr[indxArr.length - 1]
        let item = this.vilocalSecondClassCategories[index]

        // add by cpgu 2023/07/24 begin
        this.registerForm.interestedCategory = this.registerForm.interestedCategory.filter(f => f !== '-1')
        if (index == '-1') {
          this.newInterestedCategory = ''
          this.createCategoryVisible = true
          setTimeout(() => {
            // 隐藏下拉选项
            this.$refs.interestedCategorySelect.blur()
          }, 50)
        } else {
          buryingPoint(39, item['id'], item['storeTypeName'], '')
        }
        // end by cpgu
      }
    },

    loadConfigurationEmal() {
      getAction('/simple/configuration?key=sign_up_email_limit').then(response => {
        if (response.success) {
          if (response.result.configurationValue) {
            if (response.result.configurationValue !== '') {
              this.emailLimit = response.result.configurationValue
            }
          }
        } else {
          this.$message.warning(response.message)
        }
      })
    },
    getCountryCodeAbbreviation(t) {
      if (t === 'US') {
        return 'United States of America'
      } else if (t === 'AU') {
        return 'Australia'
      } else if (t === 'CA') {
        return 'Canada'
      } else if (t === 'UK') {
        return 'United Kingdom'
      } else if (t === 'NZ') {
        return 'New Zealand'
      }
    },
    handleSelect(object) {
      this.registerForm.isGoogleMap = 1
      getAction('/register/place/detail', { 'place_id': object.placeId }).then((res) => {
        if (res.success) {
          this.registerForm.storeName = res.result.storeName
          this.registerForm.storeAddress = res.result.address

          this.registerForm.state = res.result.state
          this.registerForm.city = res.result.city
          this.registerForm.zipCode = res.result.postCode
          this.registerForm.countryCode = res.result.country
          this.registerForm.country = this.getCountryCodeAbbreviation(res.result.country)
        }
      })//
    },
    getGoogleMap(query, cb) {
      let optionsGoogle = []
      if (!query || query.trim() === '') {
        cb(optionsGoogle)
        return
      }
      let countryCode = this.registerForm.code === '+1(US)' ? 'US' : this.newCountryCode
      getAction('/register/place/autocomplete', { 'keyWords': query, 'countryCode': countryCode }).then((res) => {
        if (res.success) {
          this.optionsGoogle = []
          if (res.result) {
            for (var i = 0; i < res.result.length; i++) {
              let optionValue = {
                label: res.result[i].structured_formatting.main_text,
                value: res.result[i].structured_formatting.main_text,
                address: res.result[i].structured_formatting.secondary_text,
                placeId: res.result[i].place_id
              }
              this.optionsGoogle.push(optionValue)
            }
            cb(this.optionsGoogle)
          } else {
            this.optionsGoogle = []
          }
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    changePhone(value) {
      this.registerForm.phone = value.replace(/[^\d]/g, '')
    },
    codeChange(code) {
      this.registerForm.code = code.value
      if (code.desc) {
        let numberValue = code.desc.split(':')
        this.newCountryCode = numberValue[0]
        this.registerForm.countryCode = this.registerForm.code == '+1(US)' ? 'US' : this.newCountryCode
      }
    },
    // 获取国家、手机号配置信息
    getPhoneAndCountry() {
      getAction('/sys/dict/getDictItems/reg-country-config').then(response => {
        if (response.success) {
          if (response.result) {
            this.options = response.result
            localStorage.setItem('allCountry', JSON.stringify(response.result))
          }
        } else {
          this.$message.warning(response.message)
        }
      })
    },
    checkPhone(rule, value, callback) {
      let phone = this.registerForm.phone
      let code = this.registerForm.code
      if (code === '') {
        callback(new Error('Please enter the country code'))
      }
      if (phone === '') {
        callback(new Error('Please enter the phone!'))
      }
      // 如果是美国或者英国则判断后面手机号的长度
      if (code.indexOf('+1(US)') > -1 || code.indexOf('+1(CA)') > -1) {
        if (phone.length !== 10) {
          callback(new Error('Please enter the correct number'))
        }
      }
      if (code.indexOf('+44(UK)') > -1) {
        if (phone.length !== 10 && phone.length !== 11) {
          callback(new Error('Please enter the correct number'))
        }
      }
      if (code.indexOf('+61(AU)') > -1) {
        if (phone.length !== 9) {
          callback(new Error('Please enter the correct number'))
        }
      }
      if (code.indexOf('+64(NZ)') > -1) {
        if (phone.length !== 8 && phone.length !== 9 && phone.length !== 10) {
          callback(new Error('Please enter the correct number'))
        }
      }
      this.checkOnlyEmailOrPhone(value, 'phone')
      let that = this
      setTimeout(function () {
        if (that.loginType == 'login') {
          callback(that.onlyPhoneFlag ? '' : (new Error('There’s no account associated with that phone. Try Again')))
        } else {
          callback(that.onlyPhoneFlag ? (new Error('Phone registered')) : '')
        }
      }, 300)
      // callback()
    },
    /**
     * 检查邮箱
     */
    checkEmail(rule, value, callback) {
      if (value) {
        value = value.trim()
      }
      var reg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      //  先判断格式是否正确，格式不正确则直接返回
      if (reg.test(value)) {
        //  判断我们是否有邮箱验证，
        if (this.emailLimit !== '') {
          let index = value.indexOf('@')
          if (index > -1) {
            const emailSuffix = value.substring(index, value.length)
            if (this.emailLimit.indexOf(emailSuffix) > -1) {
              callback(new Error('Please enter your email, if you cannot register, please contact customer service'))
              return
            }
            callback()
          }
          callback(new Error('Please enter the correct email address'))
          return
        }
        this.checkOnlyEmailOrPhone(value, 'email')

        let that = this
        setTimeout(function () {
          if (that.loginType == 'login') {
            callback(that.onlyEmailFlag ? '' : (new Error('There’s no account associated with that email. Try Again')))
          } else {
            callback(that.onlyEmailFlag ? (new Error('Email registered')) : '')
          }
        }, 300)
      } else {
        callback(new Error('Please enter the correct email address'))
      }
    },
    async checkOnlyEmailOrPhone(value, type) {
      let path = '/sys/user/checkOnlyUser'
      if (type == 'email') {
        let res = await getAction(path, {
          email: value
        })
        // true ：表示存在
        this.onlyEmailFlag = !res.success
      } else {
        let phoneWithCode = this.registerForm.code + '-' + value
        let res = await getAction(path, {
          phone: phoneWithCode
        })
        this.onlyPhoneFlag = !res.success
      }
    },
    createInterestedCategory() {
      this.registerForm.interestedCategory.push(this.newInterestedCategory)
      this.createCategoryVisible = false
      buryingPoint(39, '', this.newInterestedCategory, '')
    },
    /**
     * 一键下单
     */
    oneClickOrder() {
      // 判断是否登录，没登录需要跳转到下面
      if (!this.login) {
        this.$nextTick(() => {
          const element = document.getElementById('sign-up') // 或者使用具体的元素选择器，例如 document.getElementById('elementId')
          element.scrollIntoView({ behavior: 'smooth', block: 'end' })
        })
        // 每次点击都将vilocalBrand 删除重新赋值
        this.$ls.remove('vilocalBrand')
        // 如果状态不为2 则调用
        if (this.collectionBrandVilocalStatus !== 2) {
          this.$ls.set('vilocalBrand', this.collectionBrandId)
        }
        return
      }
      let userInfo = JSON.parse(localStorage.getItem('pro__userInfo'))
      let userId = userInfo.value.id
      if (!this.isExitsViLocalOrder) {
        if (this.collectionBrandVilocalStatus !== 2) {
          this.createVilocalOrder(userId)
          // // 2.0.8 vilocal-v5 新增部分 statr  先判断是否是
          // getAction(`/store/api/v0.2/shops/users/${userId}/status`).then(response => {
          //   if (response.success) {
          //     // 返回值为false 否的话再跳转到checkout，否则需要跳转到新页面
          //     if (!response.result) {
          //       // 2.0.8 vilocal-v5 新增部分 end
          //       this.createVilocalOrder(userId)
          //     } else {
          //       // 跳转到店铺审核页面 并且要把品牌ID加到缓存中
          //       // 每次点击都将vilocalBrand 删除重新赋值
          //       this.$ls.remove('vilocalBrand')
          //       // 如果状态不为2 则调用
          //       if (this.collectionBrandVilocalStatus !== 2) {
          //         this.$ls.set('vilocalBrand', this.collectionBrandId)
          //       }
          //       this.$router.push({path: '/store-info'})
          //     }
          //   } else {
          //     this.$message.warning(response.message)
          //   }
          // })
        }
        // else {
        //   this.createVilocalOrder(userId)
        // }
      }
    },
    createVilocalOrder(userId) {
      postAction(`/order/api/v0.2/users/${userId}/vi-local-orders?brand_id=${this.collectionBrandId}`).then((res) => {
        if (res.code === 200 && res.result.orderId) {
          // 2.2.2 创建完订单需要跳转到 storeinfo
          this.$router.push({path: '/store-info', query: {orderId: res.result.orderId}})
          // this.$router.push({
          //   name: 'checkout',
          //   params: {
          //     orderId: res.result.orderId
          //   }
          // })
        } else if (!res.success) {
          this.$message.warning(res.message)
        }
      })
    },
    getSimpleConfiguration() {
      getAction('/simple/configuration/group?group=not_logged_in').then(
        (response) => {
          if (response.success) {
            if (response.result) {
              for (var index = 0; index < response.result.length; index++) {
                const element = response.result[index]
                if (element.configurationKey === 'wholesale_price') {
                  if (element.configurationValue === '0') {
                    this.showWholesalePrice = false
                  } else {
                    this.showWholesalePrice = true
                  }
                }
                if (element.configurationKey === 'retail_price') {
                  if (element.configurationValue === '0') {
                    this.showReailPrice = false
                  } else {
                    this.showReailPrice = true
                  }
                }
              }
            }
          } else {
            this.$message.warning(response.message)
          }
        }
      )
    },
    confimDelete(item) {
      this.confimDeleteVis = true
      this.deleteItem = item
    },
    saveTheme(flag) {
      if (!flag) {
        this.showThemeForm = false
        this.themeName = ''
        return
      }
      if (this.themeName == '' || this.themeName == null) {
        this.$message.warning('Please enter a theme name')
      } else {
        // 保存之后需要先去后台查询产品主题列表，查询之后把当前的amodal关闭
        this.saveLoading = true
        postAction('store/tsStoreTheme/add', {
          themeName: this.themeName
        }).then((response) => {
          if (response.success) {
            this.$message.success(response.message)
            this.loadThemeList()
            this.showThemeForm = false
            this.themeName = ''
            this.saveLoading = false
          } else {
            this.$message.warning(response.message)
            this.saveLoading = false
          }
        })
      }
    },
    getToken() {
      // modify by cpgu 2021/09/13  注释以下，更改为从storage获取 begin
      /*  let strcookie = document.cookie; //获取cookie字符串
      let arrcookie = strcookie.split("; "); //分割
      //遍历匹配
      for (let i = 0; i < arrcookie.length; i++) {
        let arr = arrcookie[i].split("=");
        if (arr[0] == "token") {
          return arr[1];
        }
      }
      return ""; */
      return Vue.ls.get('token', '')
      // end by
    },
    // 删除信息
    deleteItemMethods() {
      // 防止这个值上去，要把值清空
      const item = this.deleteItem
      this.selTheme = ''
      this.deleteItemLoading = true
      deleteAction(
        this.beNetWrok + 'store/tsStoreTheme/delete?id=' + item.value
      )
        .then((response) => {
          this.deleteItemLoading = false

          if (response.success) {
            this.confimDeleteVis = false
            this.deleteItem = ''
            this.selTheme = ''
            this.$message.success(response.message)
            this.themeArr = []
            this.loadThemeList()
          } else {
            this.$message.warning(response.message)
          }
        })
        .catch(() => {
          this.deleteItemLoading = false
        })
    },
    openThemeForm() {
      this.showThemeForm = true
    },
    onSelectChange(selectedRow) {
      this.tempSelectedRow = selectedRow
      this.selectedRowKeys = selectedRow
    },
    sortList() {
      return this.countryCodeList.sort((a, b) => {
        return a['nameEn'].localeCompare(b['nameEn'])
      })
    },
    handleChange(value, record) {
      this.shippingToValue = value

      this.shippingToText = this.countryCodeList.find((item) => {
        return item.code == value
      }).nameEn
      this.loadLogistics()
    },
    // 本来打开弹框就又默认值，所以 当弹框中的下拉框变化后，需要将发货地和收货地一起传过去调用接口
    handleChangeShoppingFrom(value, record) {
      this.shippingFromValue = value
      // this.shippingFromText = record.componentOptions.children[0].text;
      this.loadLogistics()
    },
    // 获取物流信息列表
    loadLogistics() {
      this.selectedRowKeys = []
      this.selectedRows = {}
      this.shopMethodList = []
      this.tableLoading = true
      const data = {}
      data.goodsId = this.product_detail_id
      data.skuId = this.skuId
      data.startCountryCode = this.shippingFromValue
      data.countryCode = this.shippingToValue
      data.quantity = this.num

      postAction(
        this.beNetWrok + '/tsgoods/tsGoodsInfo/getLogisticsFreight-new',
        data
      )
        .then((response) => {
          if (response.success) {
            for (var index = 0; index < response.result.length; index++) {
              if (response.result[index].logisticsName.indexOf('CJ') > -1) {
                response.result[index].logisticsName = response.result[
                  index
                ].logisticsName.replace('CJ', 'Vidi')
              }
            }
            this.shopMethodList = response.result
            if (this.shopMethodList.length > 0) {
              this.tempSelectedRow = this.shopMethodList[0]
              this.selectedRowKeys.push(this.shopMethodList[0].logisticsName)
            }
            this.tableLoading = false
          } else {
            this.$message.warning(response.message)
            this.tableLoading = false
          }
        })
        .catch(() => {
          this.tableLoading = false
        })
    },
    // 显示物流信息的同时默认选中第一条
    queryShopingMethod() {
      // 详情加载完毕再允许打开弹框
      // 这个是必须有的无论加不加载都得赋值
      this.shippingToValue = this.tempShippingToValue
      this.shippingToText = this.tempShippingToText
      this.shippingFromValue = this.tempShippingFromValue
      this.shippingFromText = this.tempShippingFromText
      // 点开要判断物流方式是不是空，如果是空说明是第一次加载，需要调用查询物流接口，如果不为空，那么就不加载，然后选中当前的信息
      if (this.shoppingMethod == '') {
        // 说明是第一次加载
        this.loadLogistics()
      }
      this.showShippingMethod = true
    },
    saveShippingMethod(flag) {
      if (!flag) {
        // 如果是取消关闭弹框的话要把框里面的内容清空
        this.showShippingMethod = false
        this.shippingFromText = ''
        this.shippingFromValue = ''
        this.shippingToText = ''
        this.shippingToValue = ''
        return
      }
      // 保存要先给临时的发货地和收货地赋值再清空
      this.tempShippingFromText = this.shippingFromText
      this.tempShippingFromValue = this.shippingFromValue
      this.tempShippingToText = this.shippingToText
      this.tempShippingToValue = this.shippingToValue
      this.shippingFromText = ''
      this.shippingFromValue = ''
      this.shippingToText = ''
      this.shippingToValue = ''
      // 如果不是关闭的话就保存
      // 还要更新详情页物流的信息
      this.days = (this.tempSelectedRow || {}).arrivalTime
      this.freight = this.tempSelectedRow.postage
      this.shoppingMethod = this.tempSelectedRow.logisticsName
      this.showShippingMethod = false
      this.showShopMethodDefault = false
    },
    loadData(data) {
      let id = ''
      let type = ''
      let menuName = ''
      if (data.thirdItem !== undefined) {
        id = data.thirdItem.id
        menuName = data.thirdItem.cateName
          ? data.thirdItem.cateName
          : data.thirdItem.collectionName
        type = data.thirdItem.cateName ? 'categoryId' : 'collectionId'
      } else if (data.secondItem !== undefined) {
        id = data.secondItem.id
        menuName = data.secondItem.cateName
          ? data.secondItem.cateName
          : data.secondItem.collectionName
        type = data.secondItem.cateName ? 'categoryId' : 'collectionId'
      } else {
        id = data.menuList[0].id
        menuName = data.menuList[0].cateName
          ? data.menuList[0].cateName
          : data.menuList[0].collectionName
        type = data.menuList[0].cateName ? 'categoryId' : 'collectionId'
      }
      this.queryObject = {}
      this.queryObject = {
        ...this.queryObject,
        ...{
          [type]: id,
          menuName: menuName
        }
      }
    },
    async judgeItem() {
      this.menuObject = {}
      // 判断选中的是几级菜单，先判断localstorage里面有没有菜单的信息,如果没有则查询
      if (
        localStorage.getItem('meauData') === undefined ||
        localStorage.getItem('meauData') === null
      ) {
        await this.loadMenuList()
      }
      // 有的话则直接取
      let menuList = JSON.parse(localStorage.getItem('meauData'))
      // 循环看选择了哪一个
      if (menuList.length > 0) {
        let tempMenuObject = {}
        let selectedMenuList = []
        menuList.forEach((element) => {
          if (element.id === this.$route.params.firstId) {
            // 将这个一级放入List 然后放入menuObject
            selectedMenuList.push(element)
            tempMenuObject.menuList = selectedMenuList
            // 已经选中了1级，判断是否传了2级菜单然后再遍历一级选中2级
            if (
              this.$route.params.secondId !== undefined &&
              this.$route.params.secondId !== null
            ) {
              element.childrenList.forEach((secondChildren) => {
                if (secondChildren.id === this.$route.params.secondId) {
                  const secondItem = secondChildren
                  tempMenuObject.secondItem = secondItem
                  // 再判断是否选中的三级菜单
                  if (
                    this.$route.params.thirdId !== undefined &&
                    this.$route.params.thirdId !== null
                  ) {
                    secondItem.childrenList.forEach((thirdChildren) => {
                      if (thirdChildren.id === this.$route.params.thirdId) {
                        tempMenuObject.thirdItem = thirdChildren
                      }
                    })
                  }
                }
              })
            }
          }
        })
        this.menuObject = tempMenuObject
        this.loadData(this.menuObject)
      }
    },
    middleWare() {},

    handleOk(flag) {
      // 调用子组件selectGoods方法
      // this.$refs.goodsListTemplate.selectGoods(flag?"":this.selTheme)
      let formData = {}
      const ids = []
      ids.push(this.product_detail_id)
      formData.goodIds = ids
      formData.themeId = flag ? '' : this.selTheme
      this.subLoading = true
      postAction('/store/tsStoreGoodsInfo/importList', formData)
        .then((res) => {
          this.subLoading = false
          if (res.success) {
            this.$message.success(res.message)
          } else {
            this.$message.warning(res.message)
          }
        })
        .finally(() => {
          this.subLoading = false

          this.visible = false
          this.selTheme = undefined
        })
    },
    loadThemeList() {
      const that = this
      getAction('/store/tsStoreTheme/ts-store-theme', {}).then((res) => {
        if (res.success) {
          const arr = res.result
          let newArr = []
          for (const arrElement of arr) {
            let obj = {}
            obj.value = arrElement.uid
            obj.label = arrElement.themeName
            newArr.push(obj)
          }
          that.themeArr = newArr
        }
        if (res.code === 510) {
          this.$message.warning(res.message)
        }
      })
    },
    // 监听库存输入值的变化
    changeQuantity(value) {
      if (this.goodCase) {
        this.$nextTick(() => {
          this.num = this.countTotal(value, this.goodCase)
        })
      } else {
        this.num = value
      }
    },
    countTotal(n, base) {
      const x = n % base
      return x > 0 ? n - x + base : n
    },
    // 跳转官网
    gotoShopvidi(item) {
      this.$router.push({path: '/category' + item.path})
    },
    handleChangeByTheme(value, record) {
      this.selTheme = value
    },
    getTotalPrice() {
      this.totalPrice = (this.price * this.num).toFixed(2)
    },
    changeTabs(key) {},
    getImgAbbr(fileDetail) {
      const preImgtemp = fileDetail
      let imgObject = this.getImgSize(preImgtemp)
      return imgObject.width > imgObject.height
    },
    async selectImgAbbr(fileDetail, index) {
      const preImgtemp = fileDetail
      let imgObject = await this.getImgSize(preImgtemp)
      // console.log(imgObject)
      // notes 如何宽比高大，那么压缩宽
      this.imgWidth = imgObject.width
      this.imgHeight = imgObject.height
      this.sort = parseInt(index)
      this.preImg = preImgtemp
    },
    prev() {
      if (this.sort === 0) {
        this.sort = this.fileDetails.length - 1
      } else {
        this.sort = this.sort - 1
      }
      this.preImg = this.fileDetails[this.sort]
    },
    next() {
      if (this.sort === this.fileDetails.length - 1) {
        this.sort = 0
      } else {
        this.sort = this.sort + 1
      }
      this.preImg = this.fileDetails[this.sort]
    },
    // 跳转
    toRouter() {
      window.location.href = this.form.menuHref
      location.reload()
    },
    checkedSizeItem(e, index, no, disV) {
      const dataValue = e.target.getAttribute('data-key')
      // this.defaultIndex = 5
      // this.$refs.swipe.swipeItemCreated()
      let that = this
      that.attObj.disName = dataValue + '_' + disV
      that.attObj.changeCurIdx = no
      switch (no) {
        case 0:
          that.isActive0 = index
          that.attObj.attV0 = dataValue
          break
        case 1:
          that.isActive1 = index
          that.attObj.attV1 = dataValue
          break
        case 2:
          that.isActive2 = index
          that.attObj.attV2 = dataValue
          break
        case 3:
          that.isActive3 = index
          that.attObj.attV3 = dataValue
          break
        case 4:
          that.isActive4 = index
          that.attObj.attV4 = dataValue
          break
        case 5:
          that.isActive5 = index
          that.attObj.attV5 = dataValue
          break
      }
    },
    async getImgSize (url) {
      return new Promise((resolve, reject) => {
        let imgObj = new Image()
        imgObj.src = url
        imgObj.onload = () => {
          resolve({
            width: imgObj.width,
            height: imgObj.height
          })
        }
      })
    },
    changeNum(dir) {
      if (dir) {
        this.num = parseInt(this.num) > 2 ? parseInt(this.num) - 1 : 1
      } else {
        this.num++
      }
      this.getTotalPrice()
    },
    getEnvUrl() {
      let href = window.location.href
      let url = window.location.host
      if (href.indexOf('test') >= 0) {
        url = 'https://test-thalesmart-manage-ui2.hupofintech.com'
        return url
      }
      if (href.indexOf('localhost') >= 0) {
        url = 'http://localhost:8080'
        return url
      }
      if (href.indexOf('pre') >= 0) {
        url = 'https://pre.shopvidi.com'
        return url
      }
      if (href.indexOf('shopvidi') >= 0) {
        url = 'https://www.shopvidi.com'
        return url
      }
    },
    checkToken() {
      getAction(this.beNetWrok + 'sys/check-token').then((response) => {
        if (response.result) {
          window.location.href = this.getEnvUrl()
        }
      })
    },
    buySample() {
      if (!this.login) {
        this.$emit('showLogin')
        return
      }
      mixpanel.track('v_register_pop-up', {
        product_id: this.product_detail_id
      })
      const params = {}
      params.goodsId = this.product_detail_id
      params.skuId = this.skuId
      params.quantity = this.num
      // params.shoppingMethod = this.shoppingMethod
      // params.startCountryCode = this.tempShippingFromValue
      // params.totalFreight = this.freight
      // params.endCountryCode = this.tempShippingToValue
      params.shoppingMethod = ''
      params.startCountryCode = this.tempShippingFromValue
      params.totalFreight = ''
      params.endCountryCode = ''
      // 跳转到确认下单页面
      // window.open(this.feNetWork+'/order/my-order/steps?ids=1419967561633153026&path=%2Forder%2Fmy-order')
      // 调用下单接口
      this.checkToken()
      const path = window.location.origin
      let path1 = window.location.href.replace(path, '')
      const index = path1.lastIndexOf('/')
      path1 = path1.substring(index, path1.length)
      postAction('/order/place-order', params).then((response) => {
        if (response.success) {
          // 这里跳转到checkout 页面，需要将orderId进行传递
          this.$router.push({
            name: 'checkout',
            params: {
              orderId: response.result.orderId,
              path: path1,
              name: 'Detail'
            }
          })
          this.$message.success(response.message)
        } else {
          this.$message.warning(response.message)
          if (response.message === 'This item is sold out') {
            setTimeout(() => {
              location.reload()
            }, 500)
          }
        }
      })
    },
    getParam(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
      var r = window.location.hash.substr(1).match(reg)
      if (r != null) return unescape(r[2])
      return null
    },
    addCart() {
      if (!this.login) {
        // 没登录吧当前的url 和 参数准备好
        localStorage.setItem('url', window.location.href)
        localStorage.setItem('sku_num', this.num)
        localStorage.setItem('sku_id', this.skuId)
        this.$emit('showLogin')
        return
      }
      let formData = {}
      if (localStorage.getItem('url')) {
        formData = [
          {
            goodsId: this.product_detail_id,
            goodsStatus: 1,
            num: localStorage.getItem('sku_num'),
            skuId: localStorage.getItem('sku_id')
          }
        ]
      } else {
        formData = [
          {
            goodsId: this.product_detail_id,
            goodsStatus: 1,
            num: this.num,
            skuId: this.skuId
          }
        ]
      }
      // 商品页 加入购物车
      // eslint-disable-next-line no-undef
      mixpanel.track('c_add_cart', {
        product_id: this.product_detail_id,
        page_from: window.location.href
      })
      postAction('/order/cart/add', formData)
        .then((res) => {
          if (res.success) {
            this.$message.success(res.message)
            // TODO haoyuanw add 2021-09-15 GA
            // eslint-disable-next-line no-undef
            gtag('event', 'click', {
              event_category: 'addcart'
            })
            // haoyuanw add 2021-10-21 当加入购物车时调用PB
            // eslint-disable-next-line no-undef
            fbq('track', 'AddToCart')
            localStorage.removeItem('sku_num')
            localStorage.removeItem('url')
            localStorage.removeItem('sku_id')
            // haoyuanw add 2023-08-15 klaviyo 增加加购推送数据
            const skuObj = this.skuIdWithSkuMap.get(this.skuId)
            const addToCartObject = {
              '$value': this.num * skuObj.price,
              'AddedItemProductName': this.queryData.title,
              'AddedItemProductID': this.queryData.id,
              'AddedItemCategories': this.queryData.category,
              'AddedItemURL': window.location.href,
              'AddedItemPrice': skuObj.price,
              'AddedItemQuantity': this.num,
              'Items': {
                'ProductID': this.queryData.id,
                'SKU': skuObj.vdSku,
                'ProductName': this.queryData.title,
                'Quantity': this.num,
                'ItemPrice': skuObj.price,
                'RowTotal': this.num * skuObj.price,
                'ProductURL': window.location.href,
                'ImageURL': skuObj.imgPath,
                'ProductCategories': this.queryData.category
              }
            }
            console.log(addToCartObject)
            klaviyo.push(['track', 'Added to Cart', addToCartObject])
          } else {
            this.$message.warning(res.message)
          }
        })
        .finally(() => {})
    },
    // loadSkuCharacterUrl(characterUrl, goodsId) {
    loadSkuCharacterUrl(result) {
      const that = this
      // getAction(characterUrl, { id: goodsId }).then((res) => {
      //   if (res.success) {
      // const result = res.result
      // that.skuAttributeMap = result.attribute
      // 子级
      const attrWithSonListMap = result.attrWithSonListMap
      let tmpMap = new Map()
      for (let k in attrWithSonListMap) {
        tmpMap.set(
          k + '_' + attrWithSonListMap[k]._1,
          attrWithSonListMap[k]._2
        )
      }
      this.parentIdWithSonListMap = tmpMap

      // 动态判断下拉框
      const attributeObj = result.attribute
      let characterWithIdxObj = result.characterWithIdxMap
      for (let k in characterWithIdxObj) {
        switch (parseInt(characterWithIdxObj[k])) {
          case 0:
            that.attObj.att0Flag = true
            that.attObj.att0Name = k
            for (const ak in attributeObj) {
              if (ak == k) {
                that.attObj.att0Arr = attributeObj[ak]
                // 第一个下拉框默认选中第一个
                this.attObj.disName = attributeObj[ak][0].value + '_' + k
                this.attObj.attV0 = attributeObj[ak][0].value
                this.attObj.changeCurIdx = 0
                this.isActive0 = 0
              }
            }
            break
          case 1:
            that.attObj.att1Flag = true
            that.attObj.att1Name = k
            break
          case 2:
            that.attObj.att2Flag = true
            that.attObj.att2Name = k
            break
          case 3:
            that.attObj.att3Flag = true
            that.attObj.att3Name = k
            break
          case 4:
            that.attObj.att4Flag = true
            that.attObj.att4Name = k
            break
          case 5:
            that.attObj.att5Flag = true
            that.attObj.att5Name = k
            break
        }
      }

      // sku组合key与skuId Map
      let attrSkuObj = result.attrSku
      let attrMap = new Map()
      for (let k in attrSkuObj) {
        attrMap.set(k, attrSkuObj[k].skuId)
      }
      that.skuAttStrWithSkuIdMap = attrMap

      //   setTimeout(that.selectOtherDefaultVal, 500)
      // }
      // if (res.code === 510) {
      //   this.$message.warning(res.message)
      // }
      this.getTotalPrice()
      // })
    },
    selectOtherDefaultVal() {
      let that = this
      // TODO haoyuanw  add 2021-12-21 默认选中SKU start
      if (this.$route.params.id) {
        if (this.$route.query.sku1) {
          setTimeout(() => {
            for (var index = 0; index < this.attObj.att0Arr.length; index++) {
              if (this.attObj.att0Arr[index].value === this.$route.query.sku1) {
                // TODO 默认选中SKU需要将对应的active 赋值(主要决定样式)
                this.isActive0 = index
                // TODO 然后需要处理sku的值
                this.attObj.disName =
                  this.$route.query.sku1 + '_' + this.attObj.att0Name
                this.attObj.attV0 = this.$route.query.sku1
                break
              }
            }
          }, 300)
        }
        if (this.$route.query.sku2) {
          setTimeout(() => {
            for (
              var index2 = 0;
              index2 < this.attObj.att1Arr.length;
              index2++
            ) {
              if (
                this.attObj.att1Arr[index2].value === this.$route.query.sku2
              ) {
                this.isActive1 = index2
                // TODO 然后需要处理sku的值
                this.attObj.disName =
                  this.$route.query.sku2 + '_' + this.attObj.att1Name
                this.attObj.attV1 = this.$route.query.sku2
                break
              }
            }
          }, 300)
        }
        if (this.$route.query.sku3) {
          setTimeout(() => {
            for (
              var index3 = 0;
              index3 < this.attObj.att2Arr.length;
              index3++
            ) {
              if (
                this.attObj.att2Arr[index3].value === this.$route.query.sku3
              ) {
                this.isActive2 = index3
                // TODO 然后需要处理sku的值
                this.attObj.disName =
                  this.$route.query.sku3 + '_' + this.attObj.att2Name
                this.attObj.attV2 = this.$route.query.sku3
                break
              }
            }
          }, 300)
        }
        if (this.$route.query.sku4) {
          setTimeout(() => {
            for (
              var index4 = 0;
              index4 < this.attObj.att3Arr.length;
              index4++
            ) {
              if (
                this.attObj.att3Arr[index4].value === this.$route.query.sku4
              ) {
                this.isActive3 = index4
                // TODO 然后需要处理sku的值
                this.attObj.disName =
                  this.$route.query.sku4 + '_' + this.attObj.att3Name
                this.attObj.attV3 = this.$route.query.sku4
                break
              }
            }
          }, 300)
        }
        if (this.$route.query.sku5) {
          setTimeout(() => {
            for (
              var index5 = 0;
              index5 < this.attObj.att4Arr.length;
              index5++
            ) {
              if (
                this.attObj.att4Arr[index5].value === this.$route.query.sku5
              ) {
                this.isActive4 = index5
                // TODO 然后需要处理sku的值
                this.attObj.disName =
                  this.$route.query.sku5 + '_' + this.attObj.att4Name
                this.attObj.attV4 = this.$route.query.sku5
                break
              }
            }
          }, 300)
        }
        if (this.$route.query.sku6) {
          setTimeout(() => {
            for (
              var index6 = 0;
              index6 < this.attObj.att5Arr.length;
              index6++
            ) {
              if (
                this.attObj.att5Arr[index6].value === this.$route.query.sku6
              ) {
                this.isActive5 = index6
                // TODO 然后需要处理sku的值
                this.attObj.disName =
                  this.$route.query.sku6 + '_' + this.attObj.att5Name
                this.attObj.attV5 = this.$route.query.sku6
              }
            }
          }, 300)
        }
      }
      // TODO haoyuanw  add 2021-12-06 默认选中SKU end
      // haoyuanw add 2021-12-21 这是直接进入详情页面，默认都选中当前 规格的第一个值 start
      // 第二个值默认选中
      else {
        if (that.attObj.att1Flag) {
          let dataValue = that.attObj.att1Arr[0].value
          that.attObj.disName = dataValue + '_' + that.attObj.att1Name
          that.attObj.changeCurIdx = 1
          that.isActive1 = 0
          that.attObj.attV1 = dataValue
        }
        if (that.attObj.att2Flag) {
          setTimeout(() => {
            let dataValue = that.attObj.att2Arr[0].value
            that.attObj.disName = dataValue + '_' + that.attObj.att2Name
            that.attObj.changeCurIdx = 2
            that.isActive2 = 0
            that.attObj.attV2 = dataValue
          }, 300)
        }
        if (that.attObj.att3Flag) {
          setTimeout(() => {
            let dataValue = that.attObj.att3Arr[0].value
            that.attObj.disName = dataValue + '_' + that.attObj.att3Name
            that.attObj.changeCurIdx = 3
            that.isActive3 = 0
            that.attObj.attV3 = dataValue
          }, 300)
        }
        if (that.attObj.att4Flag) {
          setTimeout(() => {
            let dataValue = that.attObj.att4Arr[0].value
            that.attObj.disName = dataValue + '_' + that.attObj.att4Name
            that.attObj.changeCurIdx = 4
            that.isActive4 = 0
            that.attObj.attV4 = dataValue
          }, 300)
        }
        if (that.attObj.att5Flag) {
          setTimeout(() => {
            let dataValue = that.attObj.att5Arr[0].value
            that.attObj.disName = dataValue + '_' + that.attObj.att5Name
            that.attObj.changeCurIdx = 5
            that.isActive5 = 0
            that.attObj.attV5 = dataValue
          }, 300)
        }
      }

      // haoyuanw add 2021-12-21 这是直接进入详情页面，默认都选中当前 规格的第一个值 end

      // if (that.attObj.att2Arr && that.attObj.att2Arr.length > 0) {
      //   setTimeout(() => {
      //     let dataValue = that.attObj.att2Arr[0].value
      //     that.attObj.disName = dataValue + '_' + that.attObj.att2Name
      //     that.attObj.changeCurIdx = 2
      //     that.isActive2 = 0
      //     that.attObj.attV2 = dataValue
      //   }, 300)
      // }
    },
    loadParam(paramUrl, goodsId) {
      const that = this
      getAction(paramUrl, { id: goodsId }).then((res) => {
        if (res.success) {
          const result = res.result
          let skuIdWithParamsMap = new Map()
          for (let skuId in result) {
            let paramNameArr = [] // 参数名称_List参数
            let arr = result[skuId]
            for (const idx in arr) {
              const paramObj = arr[idx]

              // 判断当前特征描述是否已在数组中
              let flag = false
              let curN = 0
              let curDescArr = []
              for (let n in paramNameArr) {
                const paramNameMap = paramNameArr[n]
                for (let f in paramNameMap) {
                  if (f === paramObj.snparametersDesc) {
                    flag = true
                    curN = n
                    curDescArr = paramNameMap[f]
                    break
                  }
                }
              }

              if (flag) {
                curDescArr.push(paramObj)
                let tmpMap = {}
                tmpMap[paramObj.snparametersDesc] = curDescArr

                // 重新赋值
                paramNameArr[curN] = tmpMap
              } else {
                let skuParamArr = []
                skuParamArr.push(paramObj)

                let tmpMap = {}
                // tmpMap.set(paramObj.snparametersDesc, skuParamArr);
                tmpMap[paramObj.snparametersDesc] = skuParamArr
                paramNameArr.push(tmpMap)
              }
            }
            skuIdWithParamsMap.set(skuId, paramNameArr)
          }
          that.skuParamMap = skuIdWithParamsMap
          that.skuParamArr = skuIdWithParamsMap.get(that.skuId)
        }
        if (res.code === 510) {
          this.$message.warning(res.message)
        }
      })
    },
    gotoBrand() {
      // 如果品牌id不是初始值说明该商品有 品牌信息
      if (this.collectionBrandId !== '') {
        window.open(
          window.location.origin +
            '/brand' + this.collectionBrandSeoUrl
        )
      }
    },

    loadDetail(reqUrl, characterUrl, paramUrl) {
      postAction('/ts/seo/router/product', {
        url: this.$route.params.url
      }).then((res) => {
        if (res.success) {
          this.product_detail_id = res.result.id
          let that = this
          getAction(reqUrl, { id: that.product_detail_id }).then((res) => {
            if (res.success) {
              let spuDetail = res.result.tsGoodsInfo
              // spuDetail['descriptionRating'] = Number(spuDetail['descriptionRating'].toFixed(1))
              // spuDetail['rating'] = Number(spuDetail['rating'].toFixed(1))
              // spuDetail['logisticsRating'] = Number(spuDetail['logisticsRating'].toFixed(1))
              // spuDetail['serviceRating'] = Number(spuDetail['serviceRating'].toFixed(1))
              this.queryData = spuDetail
              this.brandShippingFreePrice = this.queryData.brandShippingFreePrice
              // 获取传来的country的值
              let countryCode = this.getParam('country')
              const result = res.result.tsGoodsInfo
              // 这里处理官网菜单点过来的情况
              this.unit = result.unit

              that.goodsTitle = result.title
              that.id = result.id
              // 处理descInfo
              // const descInfo = this.handleDescInfo(result.descInfo)
              that.goodsStatus = result.goodsStatus
              that.descInfo = result.descInfo
              that.price = result.price
              that.netPrice = result.netPrice
              that.aboutProfit = result.profit
              that.stockNum = result.stockNum
              // 重量需要重新赋值,默认选择第一个sku信息
              // if (result.skuInfoList.length > 0) {
              //   const firstSkuInfo = result.skuInfoList[0]
              //   this.weight = firstSkuInfo.weight
              //   that.vdSku = firstSkuInfo.vdSku
              //   that.skuCode = firstSkuInfo.skuCode
              //   that.weight = firstSkuInfo.weight// 重量
              //   that.goodCase = firstSkuInfo.step
              //   that.dimensions = firstSkuInfo.volume || firstSkuInfo.svolume
              //   // that.goodCase = 20
              //   if (that.goodCase) {
              //     that.num = that.goodCase
              //   }
              // }
              // that.weight=result.weight;
              that.fileDetails = result.imgList
              that.collectionBrandId = result.collectionBrandId
              that.collectionBrandLogoUrl = result.collectionBrandLogoUrl
              that.collectionBrandName = result.collectionBrandName
              that.salesManager = result.salesManager
              that.collectionBrandSeoUrl = result.collectionBrandSeoUrl
              this.$refs.brandRecommend.loadData(result.collectionBrandId, spuDetail.id)
              this.$refs.moreRecommend.loadData(result.collectionBrandId, spuDetail.category, spuDetail.id)
              this.$refs.recentlyViewed.loadData(result.collectionBrandId)
              // 埋点日志
              buryingPoint(1, this.product_detail_id, that.goodsTitle, this.$route.name)

              // sku信息
              let skuMap = new Map()
              let skuArr = result.skuInfoList
              /**
               * 2.1.0新增vilocal逻辑开始
               **/
              // let vilocalSkuNum = 0
              for (const skuArrElement of skuArr) {
                // if (skuArrElement.isVilocal) {
                //   vilocalSkuNum = x` + 1
                // }

                // // TODO 测试完删除
                // if (skuArrElement.id === '2c9f85557d3b69a6017d3bc80c3c01c8') {
                //   skuArrElement.isSales = false
                //   skuArrElement.isOldVilocalSku = true
                // }
                skuMap.set(skuArrElement.id + '', skuArrElement) // id转化为字符串
              }
              this.collectionBrandVilocalStatus = this.queryData.brandVilocalStatus
              // // 显示按钮部分
              // /**
              //  * 4个特殊品牌
              //  *   一个spu下 所有sku都为vilocal商品 ，则展示一键下单、加购按钮
              //  *   一个spu下 即有非vilocal商品 也有vilocal商品 则一键下单、加购按钮都展示
              //  *   一个spu下 全部为非vilocal商品 则展示加购按钮
              //  **/
              // if (this.specialBrandList.includes(this.collectionBrandId)) {
              //   if (vilocalSkuNum === 0) {
              //     this.showOneClickOrder = false
              //   }
              // } else {
              //   /**
              //    * 其他品牌
              //    * 一个spu下 所有sku都为vilocal商品 ，则只展示一键下单按钮 不展示加购按钮
              //    * 一个spu下 即有非vilocal商品 也有vilocal商品 则一键下单、加购按钮都展示
              //    * 一个spu下 全部为非vilocal商品 则不展示一键下单按钮 展示加购按钮
              //    * 一个spu下 有vilocal商品 并且有商品sold out/unvalivabal时候 选择售罄商品后不展示一键下单按钮
              //    **/
              //   if (vilocalSkuNum === skuArr.length && vilocalSkuNum > 0) {
              //     this.showAddToCart = false
              //   }
              //   if (vilocalSkuNum === 0) {
              //     this.showOneClickOrder = false
              //   }
              // }

              // // 2.2.6 判断是否显示 如果是vilocal商品直接展示
              // if (this.queryData.isVilocal) {
              //   this.showOneClickOrder = true
              // }

              // 判断按钮提示部分
              if (this.isExitsViLocalOrder) {
                this.tipContent = 'ViLocal order placed'
              } else {
                if (this.collectionBrandVilocalStatus === 1) {
                  this.tipContent = 'Pre-order shipments may experience delays.'
                } else if (this.collectionBrandVilocalStatus === 2) {
                  this.tipContent = 'Waiting for the next opening'
                }
              }

              /**
               * 2.1.0新增vilocal逻辑结束
               **/
              if (that.fileDetails.length > 0) {
                that.preImg = that.fileDetails[0]
              }
              that.skuIdWithSkuMap = skuMap

              // add by cpgu 一个商品一个sku才显示，否则显示有问题，会导致无法下单 2021/11/06 begin
              if (skuArr.length == 1) {
                that.skuId = result.skuId
              }
              // end by cpgu

              // 访问后台获取
              // 准备商品id，SkuId和发货地
              // ---------------Start  这里要注意，给临时的发货和收货地进行赋值用来显示详情页面，避免和弹框里面的下拉框导致公用一个值----------------
              // 收货地默认选择美国,美国这里倒序查询会快一些
              that.countryCodeList.forEach((element) => {
                if (element.code === 'US') {
                  // 遇到美国直接退出循环
                  that.tempShippingToValue = element.code
                  that.tempShippingToText = element.nameEn
                }
              })
              // ----------------End 以上是选择默认收货地  ------------------------------------------------------------------------------------------------
              // ------------------Start 下面是判断显示发货地 ----------------------
              if (
                countryCode === null ||
                countryCode === undefined ||
                countryCode === ''
              ) {
                // 如果没有传筛选国家code的情况下通过返回的第一个sku生成 发货仓的 下拉框
                if (result.skuInfoList[0].invList) {
                  // 默认值
                  if (result.skuInfoList[0].invList[0]) {
                    that.tempShippingFromValue =
                      result.skuInfoList[0].invList[0].countryCode
                    that.tempShippingFromText =
                      result.skuInfoList[0].invList[0].area
                  }
                  // 默认第一个SKu的发货地仓库集合
                  const startCountryList = []
                  const invList = result.skuInfoList[0].invList
                  for (var index = 0; index < invList.length; index++) {
                    const startCountry = {}
                    startCountry.label = invList[index].area
                    startCountry.value = invList[index].countryCode
                    startCountryList.push(startCountry)
                  }
                  that.startCountryCodeList = startCountryList
                }
              } else {
                // 如果有筛选的国家，则需要遍历该商品下的sku集合，找到发货地有传来的国家的
                skuArr.forEach((element) => {
                  element.invList.forEach((startCountry) => {
                    if (startCountry.countryCode === countryCode) {
                      // 发货地默认值
                      that.tempShippingFromValue = startCountry.countryCode
                      that.tempShippingFromText = startCountry.area
                      const startCountryList = []
                      element.invList.forEach((startCountryCode) => {
                        const startCountry = {}
                        startCountry.label = startCountryCode.area
                        startCountry.value = startCountryCode.countryCode
                        startCountryList.push(startCountry)
                      })
                      that.startCountryCodeList = startCountryList
                    }
                  })
                })
              }
              // ------------------End 上面是判断显示发货地 ----------------------
              that.isCompleted = true
              // 然后去调用CJ接口去查询对应的物流信息和价格
              // this.loadLogistics(true)
            }
            if (res.code === 510) {
              that.$message.warning(res.message)
            }
            that.getTotalPrice()
            this.loadSkuCharacterUrl(res.result.tsGoodsSkuCharacter)
            // this.loadSkuCharacterUrl(characterUrl, this.product_detail_id)
            // sem 如果缓存有数据，并且是商品详情链接，就添加购物车直接
            if (localStorage.getItem('url') && localStorage.getItem('url').indexOf('/product/') > 0) {
              this.addCart()
            }
          })
          this.handleBreadcrumb(res.result.cateId)
          // this.loadParam(paramUrl, this.product_detail_id)
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    /**
     * 更新面包屑 以分类显示
     */
    handleBreadcrumb(thirdCateId) {
      // 获取导航信息
      let menuList = JSON.parse(localStorage.getItem('meauData'))
      // 循环看选择了哪一个
      if (menuList !== null && menuList.length > 0) {
        menuList.forEach((firstElement) => {
          if (firstElement.childrenList) {
            firstElement.childrenList.forEach((secondElement) => {
              if (secondElement.childrenList) {
                secondElement.childrenList.forEach((thirdElement) => {
                  if (thirdElement.id === thirdCateId) {
                    const firstMenuObject = {}
                    firstMenuObject.id = firstElement.id
                    firstMenuObject.path = firstElement.seoUrl
                    firstMenuObject.title = firstElement.cateName
                    const secondMenuObject = {}
                    secondMenuObject.id = secondElement.id
                    secondMenuObject.path = secondElement.seoUrl
                    secondMenuObject.title = secondElement.cateName
                    const thirdMenuObject = {}
                    thirdMenuObject.id = thirdElement.id
                    thirdMenuObject.path = thirdElement.seoUrl
                    thirdMenuObject.title = thirdElement.cateName
                    this.form.menuList = []
                    this.form.menuList.push(firstMenuObject)
                    this.form.menuList.push(secondMenuObject)
                    this.form.menuList.push(thirdMenuObject)
                  }
                })
              }
            })
          }
        })
      }
    },
    blurInpNum() {
      this.num = parseInt(this.num) < 1 ? 1 : this.num
      const stockNumLocal = parseInt(this.stockNum)
      this.num = parseInt(this.num) > stockNumLocal ? stockNumLocal : this.num
    },
    switchSku() {
      let skuId = this.skuAttStrWithSkuIdMap.get(this.selSkuStr)
      if (skuId) {
        this.unAvailableSku = false
        this.skuId = skuId
        const skuObj = this.skuIdWithSkuMap.get(this.skuId)
        this.skuInfo = skuObj
        console.log(skuObj,"skuObj")
        // 2.2.6 vilocal寄售 切换SKU的时候要先判断是不是vilocal商品，如果不是，那么就按以前的显示
        // 切换要重置提示信息
        this.vilocalTypeTips = ''
        if (!this.queryData.isVilocal) {
          if (skuObj.isSales || skuObj.isSales === null) {
            this.showAddToCart = true
          } else {
            this.showAddToCart = false
          }
        } else {
          // 如果是vilocal商品 直接显示一键下单 isSales 负责显示加购按钮
          this.showOneClickOrder = true
          if (skuObj.isSales || skuObj.isSales === null) {
            this.showAddToCart = true
          } else {
            this.showAddToCart = false
          }
          // 如果是老数据则显示文案
          if (skuObj.isOldVilocalSku) {
            // 判断是否有库存
            if (skuObj.hasInventory) {
              this.vilocalTypeTips = 'Free trial set'
            } else {
              this.vilocalTypeTips = 'Trial ended. Explore other items'
            }
          } else {
            // 不是老数据就看寄售和试销的数量
            // 订单层面的提示信息
            let orderVilocalTypeTips = ''
            // SKU 层面的提示信息
            let skuVilocalTypeTips = ''
            // 是否显示SKU标识 默认显示
            let showSkuTips = true
            const freeTrialSkuCount = this.queryData.freeTrialSkuCount
            const consignSkuCount = this.queryData.consignSkuCount
            const discountTrialSkuCount = this.queryData.discountTrialSkuCount
            if (freeTrialSkuCount > 0) {
              orderVilocalTypeTips = 'order:Free trial ' + freeTrialSkuCount + ' Set. '
            }
            if (consignSkuCount > 0) {
              if (orderVilocalTypeTips === '') {
                orderVilocalTypeTips = 'order:Free returns ' + consignSkuCount + ' Set. '
              } else {
                orderVilocalTypeTips = orderVilocalTypeTips + ', Free returns ' + consignSkuCount + ' Set. '
              }
            }
            if (freeTrialSkuCount <= 0 && consignSkuCount <= 0 && discountTrialSkuCount <= 0) {
              orderVilocalTypeTips = 'Trial ended. Explore other items'
              showSkuTips = false
            }
            if (showSkuTips) {
              const freeTrialPersonLimit = skuObj.freeTrialPersonLimit
              const consignPersonLimit = skuObj.consignPersonLimit
              if (skuObj.vilocalType === 1) {
                // 试销
                // 判断库存是否存在
                if (skuObj.hasInventory) {
                  skuVilocalTypeTips = skuVilocalTypeTips + 'Free trial ' + freeTrialPersonLimit + ' Set. '
                }
              } else if (skuObj.vilocalType === 2) {
                // 寄售
                if (skuObj.hasInventory) {
                  skuVilocalTypeTips = skuVilocalTypeTips + 'Free returns ' + consignPersonLimit + ' Set. '
                }
              } else if (skuObj.vilocalType === 3) {
                // 试销+寄售
                if (skuObj.hasInventory) {
                  skuVilocalTypeTips = skuVilocalTypeTips + 'Free trial ' + freeTrialPersonLimit + ' Set, ' + 'Free returns ' + consignPersonLimit + ' Set. '
                }
              }else if(skuObj.vilocalType === 4){
                const discountTrialPersonLimit = skuObj.discountTrialPersonLimit
                const discountTrialRate = (skuObj.discountTrialDisplayRate*100).toFixed(0)

                // 折扣试销
                if (skuObj.hasInventory) {
                  skuVilocalTypeTips = `${discountTrialRate}%  off trial ${discountTrialPersonLimit} Set, orders:${discountTrialRate}% off trial ${discountTrialPersonLimit} Set`
                }
              }

              this.vilocalTypeTips = skuVilocalTypeTips
            }
            this.vilocalTypeTips = this.vilocalTypeTips + orderVilocalTypeTips
          }
        }

        if (skuObj !== undefined && skuObj !== null && JSON.stringify(skuObj) !== '{}') {
          this.preImg = skuObj.imgPath
          if (this.isMobile && this.preImg) {
          // add by cpgu 2022/07/20 对于手机端的切换sku，上面的图片轮播展示list第一次直接insert至第1个，后面切换sku直接替换上一次的第1个，不能影响原有的轮播 begin
            if (!this.firstSelSku) {
              this.fileDetails = [this.preImg, ...this.fileDetails]
              this.firstSelSku = true
            } else {
              let arr = [...this.fileDetails]
              arr.splice(0, 1, this.preImg)
              this.fileDetails = arr
            }
            // end by cpgu

            this.$refs.swipe.swipeItemCreated()
          }
          this.goodsTitle = skuObj.skuName
          this.goodCase = skuObj.step
          this.moq = skuObj.moq
          if (this.goodCase) {
            this.num = this.moq > this.goodCase ? this.moq : this.goodCase
          }
          this.price = skuObj.price
          this.discountPrice = (Number(skuObj.price)*Number(skuObj.discountTrialRate)).toFixed(2)
          this.netPrice = skuObj.netPrice
          this.aboutProfit = skuObj.profit
          this.stockNum = skuObj.stockNum
          this.weight = skuObj.weight
          this.vdSku = skuObj.vdSku
          this.skuCode = skuObj.skuCode
          this.skuStatus = skuObj.status
          this.restockDate = skuObj.restockDate
          this.skuCode = skuObj.skuCode
          this.dimensions = skuObj.volume || skuObj.svolume
          // 将发货地信息设置为 当前sku的信息 切换SKu的时候也是给临时的值赋值
          // this.tempShippingFromValue = result.skuInfoList[0].invList[0].countryCode
          // this.tempShippingFromText = result.skuInfoList[0].invList[0].area
          // 默认值
          if (skuObj.invList.length > 0) {
            this.tempShippingFromValue = skuObj.invList[0].countryCode
            this.tempShippingFromText = skuObj.invList[0].area
          }
          // 默认第一个SKu的发货地仓库集合
          const startCountryList = []
          const invList = skuObj.invList
          for (var index = 0; index < invList.length; index++) {
            const startCountry = {}
            startCountry.label = invList[index].area
            startCountry.value = invList[index].countryCode
            startCountryList.push(startCountry)
          }
          this.startCountryCodeList = startCountryList
          // this.loadLogistics(true)
          // 记录日志
          buryingPoint(2, skuId, skuObj.skuName, this.$route.name)
          // haoyuanw add 2023-08-15 增加 添加购物车 klaviyo
          const item = {
            'ProductName': this.queryData.title,
            'ProductID': this.queryData.id,
            'SKU': skuObj.vdSku,
            'Categories': this.queryData.category,
            'ImageURL': skuObj.imgPath,
            'URL': window.location.href,
            'Brand': this.queryData.collectionBrandName,
            'Price': skuObj.price,
            '$value': skuObj.price
          }
          klaviyo.push(['track', 'Viewed Product', item])
        }
      } else {
        console.log('烦死了')
        this.unAvailableSku = true
      }
    },
    switchSkuParam() {
      let that = this
      // 转换sku参数
      const arr = that.skuParamMap.get(that.skuId)
      that.skuParamArr = arr
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../styles/spu-detail.less";
.vilocal-type-tips{
  color: #FB541C;
  font-family: Satoshi-Medium;
  font-size: 14px;
  margin-bottom: 10px;
  margin-top: 10px;
}
/deep/ .el-loading-mask {
  border-radius: 50px;
}
.sit_img {
  width: 10.33px;
  height: 12.33px;
}
/deep/ .el-input__inner::-webkit-input-placeholder {
  color: #262B2F !important;
}

/deep/ .el-input__inner {
  border-radius: 5px;
}

/deep/ .el-dialog__wrapper {
  /* 设置 border-radius 属性 */
  .el-dialog{
    border-radius: 12px;
  }
}
.creae-cate-info{
  p{
    padding-top: 30px;
    font-size: 16px;
    font-weight: 500;
    color: #000000;
    padding-left: 20px;
  }

  .el-input{
    width: 90%;
    margin: 20px;
  }
  .submit{
    position: relative;
    top: -10px;
    border-radius: 5px;
    margin: 0 20px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #262B2F;
    font-family: Satoshi-Bold;
    color: #FFFFFF;
    cursor: pointer;
  }
}
.required-icon{
  color: red;
  font-weight: 800;
  position: absolute;
  top: 3px;
  left: 3px;
  z-index: 13;
}

.required-icon-phone{
  color: red;
  font-weight: 800;
  position: absolute;
  top: 3px;
  left: 80px;
  z-index: 13;
}
.vilocal-zone-main1-form-content {
  .vilocal-zone-main1-form {
    margin: 0 30px 0 50px;
  }

  .vilocal-zone-main1-form-line {
    display: inline-block;
  }

  .email-input-main1 {
    width: 402px;
  }

  .code-input-main1 {
    width: 90px;

  }

  .code-input-main1 {
    /deep/ .el-input__inner {
      padding: 0 0 0 10px;
      border: none !important;
    }
  }

  .phone-div {
    border: 1px solid #dcdfe6;
    border-radius: 5px;
    width: 311px;
    display: inline-flex;
    background-color: #FFFFFF;

  }

  .divider {
    width: 2px;
    height: 10px;
    position: relative;
    top: 15px;
    right: 10px;
    background-color: #232416;
  }

  .phone-input-main1{
    width: 240px;
    /deep/ .el-input__inner {
      border: none !important;
      padding: 0px;
    }
  }

  .store-name-input-main1 {
    width: 402px;
  }

  .store-type-input-main1 {
    width: 313px;
  }

  .store-address-input-main1 {
    width: 728px;
  }

  .store-address-input-main1 /deep/ ::placeholder {
    color: #000000;
    opacity: 1;
    font-family: Arial;
  }

  .interested-category-input-main1 {
    width:728px;
    /deep/ .el-tag{
      padding: 10px;
    }
  }
}
.vilocal-zone-main1-form-container {
  width:820px;
  height: auto;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.main1-form-title {
  text-align: center;
  font-size: 24px;
  font-family: Satoshi;
  font-weight: bold;
  color: #F3E93D;
  opacity: 1;
  margin: 52px 0 40px 0;
}

.vilocal-zone-main1-button {
  display: flex;
  justify-content: center;
  align-items: center;
  width:500px;
  height: 50px;
  font-size: 18px;
  font-family: Satoshi-Medium;
  background-color: #F3E93D;
  color: #000000;
  border: 1px solid #F3E93D;
  opacity: 1;
  border-radius: 50px;
  cursor:pointer;
}

.vilocal-zone-main4 {
  width: 100%;
  height: 521px;
  background: url('../../assets/img/vilocal/vilocal-bottom-bg.png') no-repeat;
  background-size: cover;
  background-position: center;
  border-bottom: 1px solid #707070;
  display: flex;
  align-items: center;
  justify-content: center;
  .vilocal-zone-main4-tips {
    max-width: 1400px;
    width: auto;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    .vilocal-zone-main4-tips-text {
      font-size: 24px;
      font-family: Satoshi-Bold;
      color: #F3E93D;
      opacity: 1;
    }
    .vilocal-zone-main4-tips-button {
      margin-left: 85px;
      height: 50px;
      background-color: #F3E93D;
      color: #000000;
      text-align: center;
      border-radius: 50px;
      width: 198px;
      line-height: 50px;
      font-family: Satoshi-Medium;
      cursor: pointer;
    }
  }
  .vilocal-zone-main4-form {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    .vilocal-zone-main4-form-content {
      width: 900px;
      display: flex;
      padding-top: 10px;
    }
    .vilocal-zone-main4-form-button {
      height: 50px;
      background-color: #F3E93D;
      color: #000000;
      text-align: center;
      border-radius: 50px;
      width: 198px;
      line-height: 50px;
      font-family: Satoshi-Medium;
      cursor: pointer;
    }
  }
}
@media screen and (max-width: 600px) {
  .email-input {
    width: 100%;
  }

  .phone-input {
    width: 100%;
  }

  .code-input {
    width: 100%;
  }

  .store-type-input {
    width: 100%;
  }

  .store-name-input {
    width: 100%;
  }

  .store-address-input {
    width: 100%;
  }

  .el-autocomplete {
    width: 100%;
  }

  .el-select {
    width: 100%;
  }

  .divider-pc {
    display: none;
  }

  .el-divider--vertical {
    height: 42px;
    margin: auto 10px;
  }

  .vilocal-zone-main1-form {
    margin:0 !important;
  }
  .main1-form-title{
    width:90%;
    font-size: 16px;
    font-family: Satoshi-Bold;
    color: #F3E93D;
    opacity: 1;
    margin:20px 0;
    text-align: start;
  }
  .vilocal-zone-main1-form-container {
    width: 100%;
    position: relative;
  }
  .vilocal-zone-main1-form-content {
    margin: 0 5%;
    width:90%;
    /deep/ .el-input__inner {
      padding: 0 10px;
    }
    .email-input-main1 {
      width: 100% !important;
    }

    .phone-div {
      width: 100%;
      display: inline-flex;
    }

    .store-name-input-main1 {
      width: 100% !important;
    }

    .store-address-input-main1 {
      width: 100% !important;
    }

    .code-input-main1 {
      width: 55%;

    }

    .code-input-main1 /deep/ .el-input__inner {
      padding: 0 0 0 10px;
      border: none;
    }

    .phone-input-main1 {
      width: 45%;
    }

    .divider {
      width: 1px;
    }

    .store-type-input-main1 {
      width: 100%;
    }

    .store-type-input-main1 {
      /deep/ .el-input__inner {
        height: 42px;
      }
    }

  }
  .vilocal-zone-main1-button {
    background-color: #F3E93D;
    width:90%;
    color: #232416;
    height: 40px;
    border: 1px solid #F3E93D;
    opacity: 1;
    border-radius: 50px;
    font-size: 14px;
    font-family: Satoshi-Medium;
    color: #000000;
  }
  .interested-category-input-main1{
    width:100% !important;
  }
  .vilocal-zone-main4 {
    width: 100%;
    height: auto;
    padding: 20px 0px;

    background: #232416;

    border-bottom: 1px solid #707070;
    display: flex;

    .vilocal-zone-main4-tips {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 95%;
      margin: 0 auto;

      .vilocal-zone-main4-tips-text {
        font-size: 16px;
        line-height: 20px;
      }

      .vilocal-zone-main4-tips-button {
        margin-left: 0px;
        margin-top: 12px;
        height: 40px;
        line-height: 40px;
        width: 134px;
      }
    }

    .vilocal-zone-main4-form {
      flex-direction: column;

      .vilocal-zone-main4-form-content {
        width: 95%;
      }

      .vilocal-zone-main4-form-button {
        margin-left: 0px;
        margin-top: 12px;
        height: 40px;
        line-height: 40px;
        width: 95%;
      }
    }

  }
  .creae-cate-info /deep/ .el-dialog{
    width: 98% !important;
    min-height: 15vh !important;

  }
}
</style>



// WEBPACK FOOTER //
// src/pages/detail/index.vue